// Europcar SEO içerik planı — 2026-08-05'te bir kereye mahsus üretilmiş STATİK veri.
//
// Kelime havuzu: Google Ads Keyword Planner (KeywordPlanIdeaService), 6 tohum grubu,
//   dil languageConstants/1037 (Türkçe), konum geoTargetConstants/2792 (Türkiye),
//   ağ GOOGLE_SEARCH. Üreten script: glowytics-backend/scripts/gads_keyword_ideas.py
// Kapsam eşleşmesi: blog_inventory tablosundaki 52 TR yazının başlık + slug + açıklaması.
// Lokasyon envanteri: europcar.com.tr/sitemap.xml + /konumlar hub'ı, sixt.com.tr ile kıyas.
//
// ⚠️ Rakamlar Keyword Planner bucket'ıdır (12-ay ortalaması), gerçek tık değildir.
// ⚠️ Veri canlı DEĞİL — tazelemek için yukarıdaki script yeniden çalıştırılmalı.

export const KW_TARIH = '2026-08-05';

export const KW_META = {
  "toplam": 5038,
  "jenerik": 3324,
  "marka": 934,
  "model": 747,
  "lokasyon": 33,
  "vol50": 1081
};

export const KW_KUMELER = [
  {
    "konu": "fiyat / ucuzlatma / kampanya",
    "kelime": 646,
    "hacim": 221830,
    "yazi": 10,
    "ornek": [
      "Havalimanı Araç Kiralama: Uygun Fiyat İçin Ne Zaman Rezervasyon Yapılmalı?",
      "Yabancı Turistler İçin Türkiye’de Havalimanı Araç Kiralama Rehberi"
    ],
    "top": [
      {
        "kw": "en uygun araç kiralama",
        "vol": 49500
      },
      {
        "kw": "araç kiralama fiyatları",
        "vol": 14800
      },
      {
        "kw": "kiralık araç fiyatları",
        "vol": 12100
      },
      {
        "kw": "ucuz oto kiralama",
        "vol": 12100
      },
      {
        "kw": "kiralik arac fiyat",
        "vol": 12100
      },
      {
        "kw": "oto kiralama fiyatları",
        "vol": 9900
      }
    ]
  },
  {
    "konu": "kurumsal / filo / operasyonel",
    "kelime": 512,
    "hacim": 71340,
    "yazi": 1,
    "ornek": [
      "Kurumsal Araç Kiralama ile Filo Maliyetlerini Azaltan Stratejiler"
    ],
    "top": [
      {
        "kw": "filo araç kiralama",
        "vol": 5400
      },
      {
        "kw": "kurumsal araç kiralama",
        "vol": 5400
      },
      {
        "kw": "filo kiralama",
        "vol": 4400
      },
      {
        "kw": "filokiralama",
        "vol": 4400
      },
      {
        "kw": "araç kiralama şirketleri",
        "vol": 4400
      },
      {
        "kw": "araç kiralama şirketi",
        "vol": 4400
      }
    ]
  },
  {
    "konu": "uzun dönem / aylık kiralama",
    "kelime": 325,
    "hacim": 61860,
    "yazi": 3,
    "ornek": [
      "Uzun Dönem Araç Kiralama Avantajları: Şirketler Hangi Durumlarda Tercih Ediyor?",
      "Günlük, Haftalık ve Aylık Araç Kiralama Fiyatlarını Etkileyen Kritik Faktörler"
    ],
    "top": [
      {
        "kw": "aylık araç kiralama",
        "vol": 14800
      },
      {
        "kw": "uzun dönem araç kiralama",
        "vol": 6600
      },
      {
        "kw": "uzun dönemaraç kiralama",
        "vol": 6600
      },
      {
        "kw": "yıllık araç kiralama",
        "vol": 3600
      },
      {
        "kw": "aylık kiralık araba fiyatları",
        "vol": 2400
      },
      {
        "kw": "aylık araç kiralama fiyatları",
        "vol": 1900
      }
    ]
  },
  {
    "konu": "havalimanı kiralama süreci",
    "kelime": 88,
    "hacim": 23980,
    "yazi": 6,
    "ornek": [
      "Havalimanı Araç Kiralama: Uygun Fiyat İçin Ne Zaman Rezervasyon Yapılmalı?",
      "Yabancı Turistler İçin Türkiye’de Havalimanı Araç Kiralama Rehberi"
    ],
    "top": [
      {
        "kw": "havalimanı araç kiralama",
        "vol": 14800
      },
      {
        "kw": "havaalani arac kiralama",
        "vol": 1600
      },
      {
        "kw": "araç kiralama havalimanı",
        "vol": 1600
      },
      {
        "kw": "havalimanı rent a car",
        "vol": 880
      },
      {
        "kw": "havalimanı kiralık araç",
        "vol": 720
      },
      {
        "kw": "havalimani araba kiralama",
        "vol": 480
      }
    ]
  },
  {
    "konu": "araç segmenti / vites / tip seçimi",
    "kelime": 205,
    "hacim": 21030,
    "yazi": 7,
    "ornek": [
      "Yeni Başlayanlar İçin Kiralık Elektrikli Araç Kullanım Rehberi",
      "Elektrikli Araç Kiralama Deneyimi: İlk Şarj, İlk Rota, İlk Rahatlık"
    ],
    "top": [
      {
        "kw": "minibüs kiralama",
        "vol": 2400
      },
      {
        "kw": "elektrikli araç kiralama",
        "vol": 2400
      },
      {
        "kw": "lüks araç kiralama",
        "vol": 1900
      },
      {
        "kw": "lüks araç kira",
        "vol": 1900
      },
      {
        "kw": "kiralık minibüs",
        "vol": 1600
      },
      {
        "kw": "kiralık minibüsler",
        "vol": 1600
      }
    ]
  },
  {
    "konu": "şoförlü / transfer / VIP",
    "kelime": 102,
    "hacim": 9270,
    "yazi": 1,
    "ornek": [
      "Düğün ve Özel Etkinlikler İçin Araç Kiralama Rehberi"
    ],
    "top": [
      {
        "kw": "vip araç kiralama",
        "vol": 2400
      },
      {
        "kw": "şöförlü araç kiralama",
        "vol": 1600
      },
      {
        "kw": "vip karadeniz rent a car",
        "vol": 590
      },
      {
        "kw": "kiralık minibüs şoförsüz",
        "vol": 390
      },
      {
        "kw": "günlük şoförlü araç kiralama fiyatları",
        "vol": 260
      },
      {
        "kw": "vip minibüs kiralama",
        "vol": 260
      }
    ]
  },
  {
    "konu": "yurt dışı / sınır geçişi",
    "kelime": 34,
    "hacim": 5290,
    "yazi": 2,
    "ornek": [
      "Bodrum'dan Datça'ya Araç Kiralayarak Egeli Bir Yolculuk",
      "Balkanlara Arabayla Yolculuk: Sınır Geçişleri Rehberi"
    ],
    "top": [
      {
        "kw": "yurt dışında araç kiralama",
        "vol": 1900
      },
      {
        "kw": "yurtdışı araç kiralama",
        "vol": 1900
      },
      {
        "kw": "yurtdışı araç kiralama kampanya",
        "vol": 260
      },
      {
        "kw": "yurtdışı araba kiralama",
        "vol": 260
      },
      {
        "kw": "araç kiralama yurtdışı",
        "vol": 210
      },
      {
        "kw": "yurtdışında araç kiralama",
        "vol": 110
      }
    ]
  },
  {
    "konu": "araç kiralama şartları (genel)",
    "kelime": 78,
    "hacim": 4770,
    "yazi": 3,
    "ornek": [
      "Araç Kiralamada Ehliyet Yaşı ve Sürücü Belgesi Şartları",
      "Araç Kiralamada Ek Sürücü Nedir, Ücretli midir?"
    ],
    "top": [
      {
        "kw": "araba kiralama şartları",
        "vol": 1300
      },
      {
        "kw": "araç kiralama şartları",
        "vol": 1000
      },
      {
        "kw": "araba kiralamak için şartlar",
        "vol": 320
      },
      {
        "kw": "havalimanından araç kiralama şartları",
        "vol": 170
      },
      {
        "kw": "araç kiralama için şartlar",
        "vol": 170
      },
      {
        "kw": "araç kiralarken dikkat edilmesi gerekenler",
        "vol": 170
      }
    ]
  },
  {
    "konu": "ehliyet yaşı / stajyer / genç sürücü",
    "kelime": 73,
    "hacim": 3740,
    "yazi": 1,
    "ornek": [
      "Araç Kiralamada Ehliyet Yaşı ve Sürücü Belgesi Şartları"
    ],
    "top": [
      {
        "kw": "6 aylık araç kiralama",
        "vol": 390
      },
      {
        "kw": "ehliyet 1 yıl dolmadan araç kiralama",
        "vol": 390
      },
      {
        "kw": "6 aylık araç kiralama fiyatları",
        "vol": 260
      },
      {
        "kw": "1 yıllık araç kiralama",
        "vol": 260
      },
      {
        "kw": "stajyer ehliyet araç kiralama",
        "vol": 260
      },
      {
        "kw": "araç kiralama yaş sınırı",
        "vol": 210
      }
    ]
  },
  {
    "konu": "ödeme: kredi kartı / depozito / provizyon",
    "kelime": 37,
    "hacim": 2550,
    "yazi": 3,
    "ornek": [
      "Kredi Kartsız Araç Kiralama Mümkün mü? Güncel Yöntemler ve Alternatifler",
      "İlk Kez Araç Kiralayacaklar İçin Adım Adım Kolay Rehber"
    ],
    "top": [
      {
        "kw": "kredi kartsız araç kiralama",
        "vol": 1000
      },
      {
        "kw": "depozitosuz araç kiralama",
        "vol": 390
      },
      {
        "kw": "banka kartı ile araç kiralama",
        "vol": 170
      },
      {
        "kw": "kredi kartsiz araba kiralama",
        "vol": 110
      },
      {
        "kw": "araç kiralama kredi kartsız",
        "vol": 110
      },
      {
        "kw": "kredi kartsız kiralık araba",
        "vol": 110
      }
    ]
  },
  {
    "konu": "trafik cezası & HGS/OGS",
    "kelime": 10,
    "hacim": 2180,
    "yazi": 1,
    "ornek": [
      "Kiralık Araca Ceza Gelirse Ne Olur? Trafik Cezaları Süreci"
    ],
    "top": [
      {
        "kw": "kiralık araç ceza sorgulama",
        "vol": 590
      },
      {
        "kw": "kiralık araç trafik ceza sorgulama",
        "vol": 390
      },
      {
        "kw": "kiralık araç trafik cezası sorgulama",
        "vol": 390
      },
      {
        "kw": "kiralık araç trafik cezası ödeme",
        "vol": 390
      },
      {
        "kw": "kiralık araca yazılan ceza sorgulama",
        "vol": 260
      },
      {
        "kw": "kiralık araç plakasına yazılan ceza sorgulama",
        "vol": 40
      }
    ]
  },
  {
    "konu": "km sınırı & sınırsız km",
    "kelime": 34,
    "hacim": 1560,
    "yazi": 0,
    "ornek": [],
    "top": [
      {
        "kw": "araç kiralama km sınırı",
        "vol": 170
      },
      {
        "kw": "sınırsız km araç kiralama",
        "vol": 170
      },
      {
        "kw": "kiralık araç günlük km sınırı",
        "vol": 140
      },
      {
        "kw": "tik tak günlük kiralama km sınırı",
        "vol": 140
      },
      {
        "kw": "araç kiralama günlük kilometre sınırı",
        "vol": 110
      },
      {
        "kw": "araç kiralamada günlük kilometre sınırı",
        "vol": 110
      }
    ]
  },
  {
    "konu": "sigorta / kasko / hasar / kaza",
    "kelime": 32,
    "hacim": 650,
    "yazi": 6,
    "ornek": [
      "Havalimanı Araç Kiralama Süreci Nasıl İşler? İnişten 10 Dakika Sonra Aracınızı Almanın Yolları",
      "İlk Kez Araç Kiralayacaklar İçin Adım Adım Kolay Rehber"
    ],
    "top": [
      {
        "kw": "kiralık araçla kaza yaparsan ne olur",
        "vol": 140
      },
      {
        "kw": "filo kasko nedir",
        "vol": 70
      },
      {
        "kw": "rent a car kasko nedir",
        "vol": 70
      },
      {
        "kw": "kiralık arabayla kaza",
        "vol": 30
      },
      {
        "kw": "kiralık araçla kaza yaparsak ne olur",
        "vol": 30
      },
      {
        "kw": "araç kiralama sigortası",
        "vol": 30
      }
    ]
  },
  {
    "konu": "yakıt politikası / depo",
    "kelime": 14,
    "hacim": 590,
    "yazi": 6,
    "ornek": [
      "Yeni Başlayanlar İçin Kiralık Elektrikli Araç Kullanım Rehberi",
      "Elektrikli Araç Kiralama Deneyimi: İlk Şarj, İlk Rota, İlk Rahatlık"
    ],
    "top": [
      {
        "kw": "depozitosuz araç kiralama",
        "vol": 390
      },
      {
        "kw": "araç kiralama depozito iadesi",
        "vol": 40
      },
      {
        "kw": "rent go depozito iadesi",
        "vol": 30
      },
      {
        "kw": "araç kiralama depozitosuz",
        "vol": 30
      },
      {
        "kw": "araç kiralama depozito",
        "vol": 20
      },
      {
        "kw": "kredi kartsiz depozitosuz araç kiralama",
        "vol": 20
      }
    ]
  },
  {
    "konu": "teslim / iade / tek yön",
    "kelime": 17,
    "hacim": 580,
    "yazi": 5,
    "ornek": [
      "Uçuşu Kaçırmamak İçin Araç Tesliminde Dikkat Edilecek 7 Altın Kural",
      "İlk Kez Araç Kiralayacaklar İçin Adım Adım Kolay Rehber"
    ],
    "top": [
      {
        "kw": "tek yön araç kiralama",
        "vol": 260
      },
      {
        "kw": "adrese teslim araç kiralama",
        "vol": 90
      },
      {
        "kw": "araç kiralama farklı şehirde teslim",
        "vol": 50
      },
      {
        "kw": "araç kiralama depozito iadesi",
        "vol": 40
      },
      {
        "kw": "rent go depozito iadesi",
        "vol": 30
      },
      {
        "kw": "tek yön araç kiralama kampanya",
        "vol": 20
      }
    ]
  },
  {
    "konu": "nasıl kiralanır / ilk kez",
    "kelime": 9,
    "hacim": 360,
    "yazi": 19,
    "ornek": [
      "Araç Kiralamada Ehliyet Yaşı ve Sürücü Belgesi Şartları",
      "Araç Kiralamada Ek Sürücü Nedir, Ücretli midir?"
    ],
    "top": [
      {
        "kw": "araç kiralarken nelere dikkat edilmeli",
        "vol": 110
      },
      {
        "kw": "araba nasıl kiralanır",
        "vol": 110
      },
      {
        "kw": "araç nasıl kiralanır",
        "vol": 50
      },
      {
        "kw": "araba kiralarken nelere dikkat edilmeli",
        "vol": 20
      },
      {
        "kw": "araç kiralamada nelere dikkat edilmeli",
        "vol": 20
      },
      {
        "kw": "araç kiralarken neye dikkat edilmeli",
        "vol": 20
      }
    ]
  },
  {
    "konu": "sözleşme / fatura / evrak / KDV",
    "kelime": 17,
    "hacim": 250,
    "yazi": 5,
    "ornek": [
      "Araç Kiralamada Ehliyet Yaşı ve Sürücü Belgesi Şartları",
      "Yabancı Turistler İçin Türkiye’de Havalimanı Araç Kiralama Rehberi"
    ],
    "top": [
      {
        "kw": "rent a car sözleşmesi",
        "vol": 90
      },
      {
        "kw": "araç kiralama için gerekli belgeler",
        "vol": 20
      },
      {
        "kw": "filo araç kiralama sözleşmesi",
        "vol": 10
      },
      {
        "kw": "filo kiralama sözleşmesi",
        "vol": 10
      },
      {
        "kw": "şoförlü araç kiralama için gerekli belgeler",
        "vol": 10
      },
      {
        "kw": "araç kiralama evrakları",
        "vol": 10
      }
    ]
  },
  {
    "konu": "ek sürücü & ek hizmetler",
    "kelime": 5,
    "hacim": 70,
    "yazi": 2,
    "ornek": [
      "Araç Kiralamada Ek Sürücü Nedir, Ücretli midir?",
      "Çocuklarla Arabayla Tatil: Türkiye'nin En Aile Dostu 10 Güzergahı"
    ],
    "top": [
      {
        "kw": "ek sürücü şartları",
        "vol": 50
      },
      {
        "kw": "bebek koltuğu kiralama",
        "vol": 20
      },
      {
        "kw": "ek sürücü ekleme",
        "vol": 0
      },
      {
        "kw": "çocuk koltuğu araç kiralama",
        "vol": 0
      },
      {
        "kw": "kiralık araçta ikinci sürücü",
        "vol": 0
      }
    ]
  },
  {
    "konu": "bakım / arıza / lastik / muayene",
    "kelime": 5,
    "hacim": 30,
    "yazi": 1,
    "ornek": [
      "Uzun Yolda Lastik Kontrolü ve Sürüş Güvenliği için 8 Pratik Adım"
    ],
    "top": [
      {
        "kw": "kar filo bakim kiralama anonim şirketi",
        "vol": 20
      },
      {
        "kw": "yakut oto kiralama",
        "vol": 10
      },
      {
        "kw": "kiralık araç muayene",
        "vol": 0
      },
      {
        "kw": "kiralık araba lastik patlarsa",
        "vol": 0
      },
      {
        "kw": "kiralık araç arıza yaparsa ne olur",
        "vol": 0
      }
    ]
  },
  {
    "konu": "iptal / değişiklik / rezervasyon",
    "kelime": 2,
    "hacim": 10,
    "yazi": 10,
    "ornek": [
      "Havalimanı Araç Kiralama: Uygun Fiyat İçin Ne Zaman Rezervasyon Yapılmalı?",
      "Yeni Başlayanlar İçin Kiralık Elektrikli Araç Kullanım Rehberi"
    ],
    "top": [
      {
        "kw": "otorento rezervasyon iptali",
        "vol": 10
      },
      {
        "kw": "araç kiralama iptal",
        "vol": 0
      }
    ]
  }
];

export const KW_TOP = [
  {
    "kw": "araç kiralama",
    "vol": 823000,
    "konu": "çekirdek",
    "niyet": "ticari",
    "kapsam": "yok",
    "yazi": null
  },
  {
    "kw": "arac kira",
    "vol": 823000,
    "konu": "çekirdek",
    "niyet": "ticari",
    "kapsam": "yok",
    "yazi": null
  },
  {
    "kw": "kiralık araçlar",
    "vol": 165000,
    "konu": "çekirdek",
    "niyet": "ticari",
    "kapsam": "yok",
    "yazi": null
  },
  {
    "kw": "oto kiralama",
    "vol": 135000,
    "konu": "çekirdek",
    "niyet": "ticari",
    "kapsam": "yok",
    "yazi": null
  },
  {
    "kw": "otomobil kiralama",
    "vol": 135000,
    "konu": "çekirdek",
    "niyet": "ticari",
    "kapsam": "yok",
    "yazi": null
  },
  {
    "kw": "otomol kiralama",
    "vol": 135000,
    "konu": "çekirdek",
    "niyet": "ticari",
    "kapsam": "yok",
    "yazi": null
  },
  {
    "kw": "araba kiralama",
    "vol": 110000,
    "konu": "çekirdek",
    "niyet": "ticari",
    "kapsam": "yok",
    "yazi": null
  },
  {
    "kw": "arabanı kirala",
    "vol": 110000,
    "konu": "çekirdek",
    "niyet": "ticari",
    "kapsam": "yok",
    "yazi": null
  },
  {
    "kw": "rent a car",
    "vol": 74000,
    "konu": "çekirdek",
    "niyet": "ticari",
    "kapsam": "yok",
    "yazi": null
  },
  {
    "kw": "en uygun araç kiralama",
    "vol": 49500,
    "konu": "fiyat/kampanya",
    "niyet": "ticari",
    "kapsam": "var",
    "yazi": "Havalimanı Araç Kiralama: Uygun Fiyat İçin Ne Zaman Rezervasyon Yapılmalı?"
  },
  {
    "kw": "kiralik araba",
    "vol": 40500,
    "konu": "çekirdek",
    "niyet": "ticari",
    "kapsam": "yok",
    "yazi": null
  },
  {
    "kw": "kiralık arabalar",
    "vol": 40500,
    "konu": "çekirdek",
    "niyet": "ticari",
    "kapsam": "yok",
    "yazi": null
  },
  {
    "kw": "kira araba",
    "vol": 40500,
    "konu": "çekirdek",
    "niyet": "ticari",
    "kapsam": "yok",
    "yazi": null
  },
  {
    "kw": "günlük araç kiralama",
    "vol": 33100,
    "konu": "günlük/saatlik",
    "niyet": "ticari",
    "kapsam": "var",
    "yazi": "Günlük, Haftalık ve Aylık Araç Kiralama Fiyatlarını Etkileyen Kritik Faktörler"
  },
  {
    "kw": "günlük araç kirala",
    "vol": 33100,
    "konu": "günlük/saatlik",
    "niyet": "ticari",
    "kapsam": "var",
    "yazi": "Günlük, Haftalık ve Aylık Araç Kiralama Fiyatlarını Etkileyen Kritik Faktörler"
  },
  {
    "kw": "araç kiralama fiyatları",
    "vol": 14800,
    "konu": "fiyat/kampanya",
    "niyet": "ticari",
    "kapsam": "var",
    "yazi": "Günlük, Haftalık ve Aylık Araç Kiralama Fiyatlarını Etkileyen Kritik Faktörler"
  },
  {
    "kw": "aylık araç kiralama",
    "vol": 14800,
    "konu": "uzun dönem",
    "niyet": "ticari",
    "kapsam": "var",
    "yazi": "Günlük, Haftalık ve Aylık Araç Kiralama Fiyatlarını Etkileyen Kritik Faktörler"
  },
  {
    "kw": "havalimanı araç kiralama",
    "vol": 14800,
    "konu": "havalimanı",
    "niyet": "ticari",
    "kapsam": "var",
    "yazi": "Havalimanı Araç Kiralama: Uygun Fiyat İçin Ne Zaman Rezervasyon Yapılmalı?"
  },
  {
    "kw": "kiralık araç fiyatları",
    "vol": 12100,
    "konu": "fiyat/kampanya",
    "niyet": "ticari",
    "kapsam": "var",
    "yazi": "Günlük, Haftalık ve Aylık Araç Kiralama Fiyatlarını Etkileyen Kritik Faktörler"
  },
  {
    "kw": "ucuz oto kiralama",
    "vol": 12100,
    "konu": "fiyat/kampanya",
    "niyet": "ticari",
    "kapsam": "yok",
    "yazi": null
  },
  {
    "kw": "kiralik arac fiyat",
    "vol": 12100,
    "konu": "fiyat/kampanya",
    "niyet": "ticari",
    "kapsam": "var",
    "yazi": "Havalimanı Araç Kiralama: Uygun Fiyat İçin Ne Zaman Rezervasyon Yapılmalı?"
  },
  {
    "kw": "oto kiralama fiyatları",
    "vol": 9900,
    "konu": "fiyat/kampanya",
    "niyet": "ticari",
    "kapsam": "var",
    "yazi": "Günlük, Haftalık ve Aylık Araç Kiralama Fiyatlarını Etkileyen Kritik Faktörler"
  },
  {
    "kw": "otomobil kiralama fiyatları",
    "vol": 9900,
    "konu": "fiyat/kampanya",
    "niyet": "ticari",
    "kapsam": "var",
    "yazi": "Günlük, Haftalık ve Aylık Araç Kiralama Fiyatlarını Etkileyen Kritik Faktörler"
  },
  {
    "kw": "uygun arac kiralama",
    "vol": 8100,
    "konu": "fiyat/kampanya",
    "niyet": "ticari",
    "kapsam": "var",
    "yazi": "Havalimanı Araç Kiralama: Uygun Fiyat İçin Ne Zaman Rezervasyon Yapılmalı?"
  },
  {
    "kw": "uzun dönem araç kiralama",
    "vol": 6600,
    "konu": "uzun dönem",
    "niyet": "ticari",
    "kapsam": "var",
    "yazi": "Uzun Dönem Araç Kiralama Avantajları: Şirketler Hangi Durumlarda Tercih Ediyor?"
  },
  {
    "kw": "uygun araba kiralama",
    "vol": 6600,
    "konu": "fiyat/kampanya",
    "niyet": "ticari",
    "kapsam": "var",
    "yazi": "Havalimanı Araç Kiralama: Uygun Fiyat İçin Ne Zaman Rezervasyon Yapılmalı?"
  },
  {
    "kw": "saatlik araç kiralama",
    "vol": 6600,
    "konu": "günlük/saatlik",
    "niyet": "ticari",
    "kapsam": "var",
    "yazi": "Hafta Sonu Kaçamağı: Ankara'dan 2 Saatte Gidilecek Yerler"
  },
  {
    "kw": "uzun dönemaraç kiralama",
    "vol": 6600,
    "konu": "uzun dönem",
    "niyet": "ticari",
    "kapsam": "kismi",
    "yazi": "Uzun Dönem Araç Kiralama Avantajları: Şirketler Hangi Durumlarda Tercih Ediyor?"
  },
  {
    "kw": "araba kiralama fiyatları",
    "vol": 5400,
    "konu": "fiyat/kampanya",
    "niyet": "ticari",
    "kapsam": "var",
    "yazi": "Günlük, Haftalık ve Aylık Araç Kiralama Fiyatlarını Etkileyen Kritik Faktörler"
  },
  {
    "kw": "filo araç kiralama",
    "vol": 5400,
    "konu": "kurumsal/filo",
    "niyet": "ticari",
    "kapsam": "var",
    "yazi": "Kurumsal Araç Kiralama ile Filo Maliyetlerini Azaltan Stratejiler"
  },
  {
    "kw": "kurumsal araç kiralama",
    "vol": 5400,
    "konu": "kurumsal/filo",
    "niyet": "ticari",
    "kapsam": "var",
    "yazi": "Kurumsal Araç Kiralama ile Filo Maliyetlerini Azaltan Stratejiler"
  },
  {
    "kw": "filo kiralama",
    "vol": 4400,
    "konu": "kurumsal/filo",
    "niyet": "ticari",
    "kapsam": "var",
    "yazi": "Kurumsal Araç Kiralama ile Filo Maliyetlerini Azaltan Stratejiler"
  },
  {
    "kw": "ucuz araç kiralama",
    "vol": 4400,
    "konu": "fiyat/kampanya",
    "niyet": "ticari",
    "kapsam": "yok",
    "yazi": null
  },
  {
    "kw": "araç kiralama şirketleri",
    "vol": 4400,
    "konu": "kurumsal/filo",
    "niyet": "ticari",
    "kapsam": "yok",
    "yazi": null
  },
  {
    "kw": "günlük araba kiralama",
    "vol": 4400,
    "konu": "günlük/saatlik",
    "niyet": "ticari",
    "kapsam": "var",
    "yazi": "Günlük, Haftalık ve Aylık Araç Kiralama Fiyatlarını Etkileyen Kritik Faktörler"
  },
  {
    "kw": "araç kiralama şirketi",
    "vol": 4400,
    "konu": "kurumsal/filo",
    "niyet": "ticari",
    "kapsam": "yok",
    "yazi": null
  },
  {
    "kw": "ucuz arac kirala",
    "vol": 4400,
    "konu": "fiyat/kampanya",
    "niyet": "ticari",
    "kapsam": "yok",
    "yazi": null
  },
  {
    "kw": "ucuza arac kiralama",
    "vol": 4400,
    "konu": "fiyat/kampanya",
    "niyet": "ticari",
    "kapsam": "yok",
    "yazi": null
  },
  {
    "kw": "araç kiralayan şirketler",
    "vol": 4400,
    "konu": "kurumsal/filo",
    "niyet": "ticari",
    "kapsam": "kismi",
    "yazi": "Uzun Dönem Araç Kiralama Avantajları: Şirketler Hangi Durumlarda Tercih Ediyor?"
  },
  {
    "kw": "enucuz araç kiralama",
    "vol": 3600,
    "konu": "fiyat/kampanya",
    "niyet": "ticari",
    "kapsam": "yok",
    "yazi": null
  },
  {
    "kw": "yıllık araç kiralama",
    "vol": 3600,
    "konu": "uzun dönem",
    "niyet": "ticari",
    "kapsam": "yok",
    "yazi": null
  },
  {
    "kw": "en ucuz araç kiralama",
    "vol": 3600,
    "konu": "fiyat/kampanya",
    "niyet": "ticari",
    "kapsam": "yok",
    "yazi": null
  },
  {
    "kw": "saatlik araba kiralama",
    "vol": 3600,
    "konu": "günlük/saatlik",
    "niyet": "ticari",
    "kapsam": "var",
    "yazi": "Hafta Sonu Kaçamağı: Ankara'dan 2 Saatte Gidilecek Yerler"
  },
  {
    "kw": "minibüs kiralama",
    "vol": 2400,
    "konu": "araç tipi/vites",
    "niyet": "ticari",
    "kapsam": "yok",
    "yazi": null
  },
  {
    "kw": "kiralık araba fiyatları",
    "vol": 2400,
    "konu": "fiyat/kampanya",
    "niyet": "ticari",
    "kapsam": "var",
    "yazi": "Günlük, Haftalık ve Aylık Araç Kiralama Fiyatlarını Etkileyen Kritik Faktörler"
  },
  {
    "kw": "günlük araba kiralama fiyatları",
    "vol": 2400,
    "konu": "fiyat/kampanya",
    "niyet": "ticari",
    "kapsam": "var",
    "yazi": "Günlük, Haftalık ve Aylık Araç Kiralama Fiyatlarını Etkileyen Kritik Faktörler"
  },
  {
    "kw": "aylık kiralık araba fiyatları",
    "vol": 2400,
    "konu": "uzun dönem",
    "niyet": "ticari",
    "kapsam": "var",
    "yazi": "Günlük, Haftalık ve Aylık Araç Kiralama Fiyatlarını Etkileyen Kritik Faktörler"
  },
  {
    "kw": "kiralık araba fiyatı",
    "vol": 2400,
    "konu": "fiyat/kampanya",
    "niyet": "ticari",
    "kapsam": "yok",
    "yazi": null
  },
  {
    "kw": "elektrikli araç kiralama",
    "vol": 2400,
    "konu": "araç tipi/vites",
    "niyet": "ticari",
    "kapsam": "var",
    "yazi": "Yeni Başlayanlar İçin Kiralık Elektrikli Araç Kullanım Rehberi"
  },
  {
    "kw": "vip araç kiralama",
    "vol": 2400,
    "konu": "şoförlü/VIP",
    "niyet": "ticari",
    "kapsam": "yok",
    "yazi": null
  },
  {
    "kw": "kiralik araba fiyat",
    "vol": 2400,
    "konu": "fiyat/kampanya",
    "niyet": "ticari",
    "kapsam": "var",
    "yazi": "Havalimanı Araç Kiralama: Uygun Fiyat İçin Ne Zaman Rezervasyon Yapılmalı?"
  },
  {
    "kw": "yurt dışında araç kiralama",
    "vol": 1900,
    "konu": "yurt dışı",
    "niyet": "ticari",
    "kapsam": "yok",
    "yazi": null
  },
  {
    "kw": "lüks araç kiralama",
    "vol": 1900,
    "konu": "araç tipi/vites",
    "niyet": "ticari",
    "kapsam": "yok",
    "yazi": null
  },
  {
    "kw": "araç kiralama kampanya",
    "vol": 1900,
    "konu": "fiyat/kampanya",
    "niyet": "ticari",
    "kapsam": "var",
    "yazi": "Araç Kiralama Kampanyalarıyla Uygun Ve Kolay Araç Kiralama Rehberi"
  },
  {
    "kw": "aylık araç kiralama fiyatları",
    "vol": 1900,
    "konu": "uzun dönem",
    "niyet": "ticari",
    "kapsam": "var",
    "yazi": "Günlük, Haftalık ve Aylık Araç Kiralama Fiyatlarını Etkileyen Kritik Faktörler"
  },
  {
    "kw": "araç kiralama kampanyası",
    "vol": 1900,
    "konu": "fiyat/kampanya",
    "niyet": "ticari",
    "kapsam": "yok",
    "yazi": null
  },
  {
    "kw": "aylık araç kiralama fiyat",
    "vol": 1900,
    "konu": "uzun dönem",
    "niyet": "ticari",
    "kapsam": "var",
    "yazi": "Günlük, Haftalık ve Aylık Araç Kiralama Fiyatlarını Etkileyen Kritik Faktörler"
  },
  {
    "kw": "lüks araç kira",
    "vol": 1900,
    "konu": "araç tipi/vites",
    "niyet": "ticari",
    "kapsam": "yok",
    "yazi": null
  },
  {
    "kw": "günlük kiralık araba",
    "vol": 1900,
    "konu": "günlük/saatlik",
    "niyet": "ticari",
    "kapsam": "var",
    "yazi": "Günlük, Haftalık ve Aylık Araç Kiralama Fiyatlarını Etkileyen Kritik Faktörler"
  },
  {
    "kw": "yurtdışı araç kiralama",
    "vol": 1900,
    "konu": "yurt dışı",
    "niyet": "bilgi",
    "kapsam": "yok",
    "yazi": null
  },
  {
    "kw": "araba kiralama şirketleri",
    "vol": 1900,
    "konu": "kurumsal/filo",
    "niyet": "ticari",
    "kapsam": "yok",
    "yazi": null
  },
  {
    "kw": "araba kiralama şirketi",
    "vol": 1900,
    "konu": "kurumsal/filo",
    "niyet": "ticari",
    "kapsam": "yok",
    "yazi": null
  },
  {
    "kw": "şöförlü araç kiralama",
    "vol": 1600,
    "konu": "şoförlü/VIP",
    "niyet": "ticari",
    "kapsam": "yok",
    "yazi": null
  },
  {
    "kw": "günlük araç kiralama fiyatları",
    "vol": 1600,
    "konu": "fiyat/kampanya",
    "niyet": "ticari",
    "kapsam": "var",
    "yazi": "Günlük, Haftalık ve Aylık Araç Kiralama Fiyatlarını Etkileyen Kritik Faktörler"
  },
  {
    "kw": "kiralık minibüs",
    "vol": 1600,
    "konu": "araç tipi/vites",
    "niyet": "ticari",
    "kapsam": "yok",
    "yazi": null
  },
  {
    "kw": "en uygun araba kiralama",
    "vol": 1600,
    "konu": "fiyat/kampanya",
    "niyet": "ticari",
    "kapsam": "var",
    "yazi": "Havalimanı Araç Kiralama: Uygun Fiyat İçin Ne Zaman Rezervasyon Yapılmalı?"
  },
  {
    "kw": "kiralık minibüsler",
    "vol": 1600,
    "konu": "araç tipi/vites",
    "niyet": "ticari",
    "kapsam": "yok",
    "yazi": null
  },
  {
    "kw": "aylık kiralık araç",
    "vol": 1600,
    "konu": "uzun dönem",
    "niyet": "ticari",
    "kapsam": "var",
    "yazi": "Günlük, Haftalık ve Aylık Araç Kiralama Fiyatlarını Etkileyen Kritik Faktörler"
  },
  {
    "kw": "havaalani arac kiralama",
    "vol": 1600,
    "konu": "havalimanı",
    "niyet": "ticari",
    "kapsam": "yok",
    "yazi": null
  },
  {
    "kw": "araç kiralama havalimanı",
    "vol": 1600,
    "konu": "havalimanı",
    "niyet": "ticari",
    "kapsam": "var",
    "yazi": "Havalimanı Araç Kiralama: Uygun Fiyat İçin Ne Zaman Rezervasyon Yapılmalı?"
  },
  {
    "kw": "12 ay araç kiralama fiyatları",
    "vol": 1300,
    "konu": "fiyat/kampanya",
    "niyet": "ticari",
    "kapsam": "var",
    "yazi": "Günlük, Haftalık ve Aylık Araç Kiralama Fiyatlarını Etkileyen Kritik Faktörler"
  },
  {
    "kw": "hara filo",
    "vol": 1300,
    "konu": "kurumsal/filo",
    "niyet": "ticari",
    "kapsam": "kismi",
    "yazi": "Kurumsal Araç Kiralama ile Filo Maliyetlerini Azaltan Stratejiler"
  },
  {
    "kw": "araba kiralama şartları",
    "vol": 1300,
    "konu": "şartlar",
    "niyet": "bilgi",
    "kapsam": "var",
    "yazi": "Araç Kiralamada Ehliyet Yaşı ve Sürücü Belgesi Şartları"
  },
  {
    "kw": "günlük oto kiralama",
    "vol": 1300,
    "konu": "günlük/saatlik",
    "niyet": "ticari",
    "kapsam": "var",
    "yazi": "Günlük, Haftalık ve Aylık Araç Kiralama Fiyatlarını Etkileyen Kritik Faktörler"
  },
  {
    "kw": "gunluk kiralik arac",
    "vol": 1300,
    "konu": "günlük/saatlik",
    "niyet": "ticari",
    "kapsam": "var",
    "yazi": "Günlük, Haftalık ve Aylık Araç Kiralama Fiyatlarını Etkileyen Kritik Faktörler"
  },
  {
    "kw": "günlük otomobil kiralama",
    "vol": 1300,
    "konu": "günlük/saatlik",
    "niyet": "ticari",
    "kapsam": "var",
    "yazi": "Günlük, Haftalık ve Aylık Araç Kiralama Fiyatlarını Etkileyen Kritik Faktörler"
  },
  {
    "kw": "garanti filo iletişim",
    "vol": 1000,
    "konu": "kurumsal/filo",
    "niyet": "ticari",
    "kapsam": "yok",
    "yazi": null
  },
  {
    "kw": "arac kiralama en uygun",
    "vol": 1000,
    "konu": "fiyat/kampanya",
    "niyet": "ticari",
    "kapsam": "var",
    "yazi": "Havalimanı Araç Kiralama: Uygun Fiyat İçin Ne Zaman Rezervasyon Yapılmalı?"
  },
  {
    "kw": "araç kiralama şartları",
    "vol": 1000,
    "konu": "şartlar",
    "niyet": "bilgi",
    "kapsam": "var",
    "yazi": "Araç Kiralamada Ehliyet Yaşı ve Sürücü Belgesi Şartları"
  },
  {
    "kw": "kredi kartsız araç kiralama",
    "vol": 1000,
    "konu": "ödeme/depozito",
    "niyet": "ticari",
    "kapsam": "var",
    "yazi": "Kredi Kartsız Araç Kiralama Mümkün mü? Güncel Yöntemler ve Alternatifler"
  },
  {
    "kw": "en uygun kiralık araç",
    "vol": 1000,
    "konu": "fiyat/kampanya",
    "niyet": "ticari",
    "kapsam": "var",
    "yazi": "Havalimanı Araç Kiralama: Uygun Fiyat İçin Ne Zaman Rezervasyon Yapılmalı?"
  },
  {
    "kw": "en iyi araç kiralama şirketleri",
    "vol": 1000,
    "konu": "kurumsal/filo",
    "niyet": "ticari",
    "kapsam": "kismi",
    "yazi": "Doğu Anadolu'yu Arabayla Gezmek: Güzergah, Konaklama ve Bilmeniz Gerekenler"
  },
  {
    "kw": "araç kiralama günlük",
    "vol": 1000,
    "konu": "günlük/saatlik",
    "niyet": "ticari",
    "kapsam": "var",
    "yazi": "Günlük, Haftalık ve Aylık Araç Kiralama Fiyatlarını Etkileyen Kritik Faktörler"
  },
  {
    "kw": "en iyi araç kiralama şirketi",
    "vol": 1000,
    "konu": "kurumsal/filo",
    "niyet": "ticari",
    "kapsam": "kismi",
    "yazi": "Doğu Anadolu'yu Arabayla Gezmek: Güzergah, Konaklama ve Bilmeniz Gerekenler"
  },
  {
    "kw": "yıllık araç kiralama fiyatları",
    "vol": 880,
    "konu": "uzun dönem",
    "niyet": "ticari",
    "kapsam": "kismi",
    "yazi": "Günlük, Haftalık ve Aylık Araç Kiralama Fiyatlarını Etkileyen Kritik Faktörler"
  },
  {
    "kw": "en ucuz aylık araç kiralama fiyatları",
    "vol": 880,
    "konu": "uzun dönem",
    "niyet": "ticari",
    "kapsam": "kismi",
    "yazi": "Günlük, Haftalık ve Aylık Araç Kiralama Fiyatlarını Etkileyen Kritik Faktörler"
  },
  {
    "kw": "filo rent a car",
    "vol": 880,
    "konu": "kurumsal/filo",
    "niyet": "ticari",
    "kapsam": "var",
    "yazi": "Kurumsal Araç Kiralama ile Filo Maliyetlerini Azaltan Stratejiler"
  },
  {
    "kw": "araba leasing fiyatları",
    "vol": 880,
    "konu": "kurumsal/filo",
    "niyet": "ticari",
    "kapsam": "kismi",
    "yazi": "Günlük, Haftalık ve Aylık Araç Kiralama Fiyatlarını Etkileyen Kritik Faktörler"
  },
  {
    "kw": "yıllık araç kiralama fiyatı",
    "vol": 880,
    "konu": "uzun dönem",
    "niyet": "ticari",
    "kapsam": "yok",
    "yazi": null
  },
  {
    "kw": "ucuz araba kiralama",
    "vol": 880,
    "konu": "fiyat/kampanya",
    "niyet": "ticari",
    "kapsam": "yok",
    "yazi": null
  },
  {
    "kw": "havalimanı rent a car",
    "vol": 880,
    "konu": "havalimanı",
    "niyet": "ticari",
    "kapsam": "var",
    "yazi": "Havalimanı Araç Kiralama: Uygun Fiyat İçin Ne Zaman Rezervasyon Yapılmalı?"
  },
  {
    "kw": "araç kiralama aylık",
    "vol": 880,
    "konu": "uzun dönem",
    "niyet": "ticari",
    "kapsam": "var",
    "yazi": "Günlük, Haftalık ve Aylık Araç Kiralama Fiyatlarını Etkileyen Kritik Faktörler"
  },
  {
    "kw": "araba leasing",
    "vol": 880,
    "konu": "kurumsal/filo",
    "niyet": "ticari",
    "kapsam": "yok",
    "yazi": null
  },
  {
    "kw": "uber ilk yolculuk indirimi",
    "vol": 880,
    "konu": "fiyat/kampanya",
    "niyet": "ticari",
    "kapsam": "yok",
    "yazi": null
  },
  {
    "kw": "en ucuz kiralık araba fiyatları",
    "vol": 720,
    "konu": "fiyat/kampanya",
    "niyet": "ticari",
    "kapsam": "kismi",
    "yazi": "Günlük, Haftalık ve Aylık Araç Kiralama Fiyatlarını Etkileyen Kritik Faktörler"
  },
  {
    "kw": "en ucuz araba kiralama",
    "vol": 720,
    "konu": "fiyat/kampanya",
    "niyet": "ticari",
    "kapsam": "yok",
    "yazi": null
  },
  {
    "kw": "araç kiralama filo",
    "vol": 720,
    "konu": "kurumsal/filo",
    "niyet": "ticari",
    "kapsam": "var",
    "yazi": "Kurumsal Araç Kiralama ile Filo Maliyetlerini Azaltan Stratejiler"
  },
  {
    "kw": "nsi filo",
    "vol": 720,
    "konu": "kurumsal/filo",
    "niyet": "ticari",
    "kapsam": "kismi",
    "yazi": "Kiralık Araca Ceza Gelirse Ne Olur? Trafik Cezaları Süreci"
  },
  {
    "kw": "aylık araba kiralama",
    "vol": 720,
    "konu": "uzun dönem",
    "niyet": "ticari",
    "kapsam": "var",
    "yazi": "Günlük, Haftalık ve Aylık Araç Kiralama Fiyatlarını Etkileyen Kritik Faktörler"
  },
  {
    "kw": "havalimanı kiralık araç",
    "vol": 720,
    "konu": "havalimanı",
    "niyet": "ticari",
    "kapsam": "var",
    "yazi": "Havalimanı Araç Kiralama: Uygun Fiyat İçin Ne Zaman Rezervasyon Yapılmalı?"
  },
  {
    "kw": "aylik araba kirala",
    "vol": 720,
    "konu": "uzun dönem",
    "niyet": "ticari",
    "kapsam": "var",
    "yazi": "Günlük, Haftalık ve Aylık Araç Kiralama Fiyatlarını Etkileyen Kritik Faktörler"
  },
  {
    "kw": "uzun dönem araç kiralama fiyatları",
    "vol": 590,
    "konu": "uzun dönem",
    "niyet": "ticari",
    "kapsam": "kismi",
    "yazi": "Uzun Dönem Araç Kiralama Avantajları: Şirketler Hangi Durumlarda Tercih Ediyor?"
  },
  {
    "kw": "aylık araba kiralama fiyatları",
    "vol": 590,
    "konu": "uzun dönem",
    "niyet": "ticari",
    "kapsam": "var",
    "yazi": "Günlük, Haftalık ve Aylık Araç Kiralama Fiyatlarını Etkileyen Kritik Faktörler"
  },
  {
    "kw": "haftalık araç kiralama",
    "vol": 590,
    "konu": "uzun dönem",
    "niyet": "ticari",
    "kapsam": "var",
    "yazi": "Günlük, Haftalık ve Aylık Araç Kiralama Fiyatlarını Etkileyen Kritik Faktörler"
  },
  {
    "kw": "hedef filo iletişim",
    "vol": 590,
    "konu": "kurumsal/filo",
    "niyet": "ticari",
    "kapsam": "yok",
    "yazi": null
  },
  {
    "kw": "panelvan kiralama",
    "vol": 590,
    "konu": "araç tipi/vites",
    "niyet": "ticari",
    "kapsam": "yok",
    "yazi": null
  },
  {
    "kw": "zeplin car fiyat listesi",
    "vol": 590,
    "konu": "fiyat/kampanya",
    "niyet": "ticari",
    "kapsam": "yok",
    "yazi": null
  },
  {
    "kw": "1 aylık araç kiralama fiyatları",
    "vol": 590,
    "konu": "uzun dönem",
    "niyet": "ticari",
    "kapsam": "var",
    "yazi": "Günlük, Haftalık ve Aylık Araç Kiralama Fiyatlarını Etkileyen Kritik Faktörler"
  },
  {
    "kw": "aylık araba kiralama fiyat",
    "vol": 590,
    "konu": "uzun dönem",
    "niyet": "ticari",
    "kapsam": "var",
    "yazi": "Günlük, Haftalık ve Aylık Araç Kiralama Fiyatlarını Etkileyen Kritik Faktörler"
  },
  {
    "kw": "escar filo",
    "vol": 590,
    "konu": "kurumsal/filo",
    "niyet": "ticari",
    "kapsam": "kismi",
    "yazi": "Kurumsal Araç Kiralama ile Filo Maliyetlerini Azaltan Stratejiler"
  },
  {
    "kw": "filo kiralık araba",
    "vol": 590,
    "konu": "kurumsal/filo",
    "niyet": "ticari",
    "kapsam": "var",
    "yazi": "Kurumsal Araç Kiralama ile Filo Maliyetlerini Azaltan Stratejiler"
  },
  {
    "kw": "1 aylık araç kiralama fiyatı",
    "vol": 590,
    "konu": "uzun dönem",
    "niyet": "ticari",
    "kapsam": "kismi",
    "yazi": "Günlük, Haftalık ve Aylık Araç Kiralama Fiyatlarını Etkileyen Kritik Faktörler"
  },
  {
    "kw": "en uygun kiralık araç fiyatları",
    "vol": 590,
    "konu": "fiyat/kampanya",
    "niyet": "ticari",
    "kapsam": "var",
    "yazi": "Günlük, Haftalık ve Aylık Araç Kiralama Fiyatlarını Etkileyen Kritik Faktörler"
  },
  {
    "kw": "uzun dönem araç kiralama fiyatlar",
    "vol": 590,
    "konu": "uzun dönem",
    "niyet": "ticari",
    "kapsam": "kismi",
    "yazi": "Uzun Dönem Araç Kiralama Avantajları: Şirketler Hangi Durumlarda Tercih Ediyor?"
  },
  {
    "kw": "kurumsal araç kiralama şirketleri",
    "vol": 590,
    "konu": "kurumsal/filo",
    "niyet": "ticari",
    "kapsam": "kismi",
    "yazi": "Kurumsal Araç Kiralama ile Filo Maliyetlerini Azaltan Stratejiler"
  },
  {
    "kw": "7 kişilik araç kiralama",
    "vol": 590,
    "konu": "araç tipi/vites",
    "niyet": "ticari",
    "kapsam": "yok",
    "yazi": null
  },
  {
    "kw": "aylik arac kirala",
    "vol": 590,
    "konu": "uzun dönem",
    "niyet": "ticari",
    "kapsam": "var",
    "yazi": "Günlük, Haftalık ve Aylık Araç Kiralama Fiyatlarını Etkileyen Kritik Faktörler"
  },
  {
    "kw": "kiralık araç ceza sorgulama",
    "vol": 590,
    "konu": "ceza/HGS",
    "niyet": "bilgi",
    "kapsam": "kismi",
    "yazi": "Kiralık Araca Ceza Gelirse Ne Olur? Trafik Cezaları Süreci"
  },
  {
    "kw": "uygun fiyata araç kiralama",
    "vol": 480,
    "konu": "fiyat/kampanya",
    "niyet": "ticari",
    "kapsam": "kismi",
    "yazi": "Havalimanı Araç Kiralama: Uygun Fiyat İçin Ne Zaman Rezervasyon Yapılmalı?"
  },
  {
    "kw": "drdfilo",
    "vol": 480,
    "konu": "kurumsal/filo",
    "niyet": "ticari",
    "kapsam": "yok",
    "yazi": null
  },
  {
    "kw": "havalimani araba kiralama",
    "vol": 480,
    "konu": "havalimanı",
    "niyet": "ticari",
    "kapsam": "var",
    "yazi": "Havalimanı Araç Kiralama: Uygun Fiyat İçin Ne Zaman Rezervasyon Yapılmalı?"
  },
  {
    "kw": "araç kiralama kurumsal",
    "vol": 480,
    "konu": "kurumsal/filo",
    "niyet": "ticari",
    "kapsam": "var",
    "yazi": "Kurumsal Araç Kiralama ile Filo Maliyetlerini Azaltan Stratejiler"
  },
  {
    "kw": "en ucuz aylık araç kiralama",
    "vol": 480,
    "konu": "uzun dönem",
    "niyet": "ticari",
    "kapsam": "kismi",
    "yazi": "Günlük, Haftalık ve Aylık Araç Kiralama Fiyatlarını Etkileyen Kritik Faktörler"
  },
  {
    "kw": "aylık kiralık araba",
    "vol": 390,
    "konu": "uzun dönem",
    "niyet": "ticari",
    "kapsam": "var",
    "yazi": "Günlük, Haftalık ve Aylık Araç Kiralama Fiyatlarını Etkileyen Kritik Faktörler"
  },
  {
    "kw": "uzun dönem kiralama",
    "vol": 390,
    "konu": "uzun dönem",
    "niyet": "ticari",
    "kapsam": "var",
    "yazi": "Uzun Dönem Araç Kiralama Avantajları: Şirketler Hangi Durumlarda Tercih Ediyor?"
  },
  {
    "kw": "kiralık minibüs şoförsüz",
    "vol": 390,
    "konu": "araç tipi/vites",
    "niyet": "ticari",
    "kapsam": "yok",
    "yazi": null
  },
  {
    "kw": "rent a car fiyatları",
    "vol": 390,
    "konu": "fiyat/kampanya",
    "niyet": "ticari",
    "kapsam": "var",
    "yazi": "Günlük, Haftalık ve Aylık Araç Kiralama Fiyatlarını Etkileyen Kritik Faktörler"
  },
  {
    "kw": "garanti filo araç kiralama",
    "vol": 390,
    "konu": "kurumsal/filo",
    "niyet": "ticari",
    "kapsam": "kismi",
    "yazi": "Kurumsal Araç Kiralama ile Filo Maliyetlerini Azaltan Stratejiler"
  },
  {
    "kw": "şirkete araç kiralamak",
    "vol": 390,
    "konu": "kurumsal/filo",
    "niyet": "ticari",
    "kapsam": "yok",
    "yazi": null
  },
  {
    "kw": "yıllık araba kiralama",
    "vol": 390,
    "konu": "uzun dönem",
    "niyet": "ticari",
    "kapsam": "yok",
    "yazi": null
  }
];

export const BLOG_BRIEFLERI = [
  {
    "no": 1,
    "baslik": "Kiralık Araçta Kilometre Sınırı: Günlük Kaç KM Hakkınız Var, Aşarsanız Ne Ödersiniz?",
    "kume": "km sınırı & sınırsız km",
    "seviye": "sifir",
    "hacim": 1560,
    "kelimeSayisi": 34,
    "bosluk": "Blogdaki tek gerçek sıfır: kümede hiç yazı yok.",
    "kws": [
      {
        "kw": "araç kiralama km sınırı",
        "vol": 170
      },
      {
        "kw": "sınırsız km araç kiralama",
        "vol": 170
      },
      {
        "kw": "kiralık araç günlük km sınırı",
        "vol": 140
      },
      {
        "kw": "araç kiralama günlük kilometre sınırı",
        "vol": 110
      },
      {
        "kw": "araç kiralamada günlük kilometre sınırı",
        "vol": 110
      },
      {
        "kw": "km sınırsız araç kiralama",
        "vol": 90
      },
      {
        "kw": "km sınırı olmayan araç kiralama",
        "vol": 70
      },
      {
        "kw": "kiralık araba kilometre sınırı",
        "vol": 70
      },
      {
        "kw": "araç kiralama km sınırı aşıldı",
        "vol": 50
      }
    ],
    "sorular": [
      "Günlük / haftalık / aylık paketlerde standart km hakkı",
      "Aşım ücreti nasıl hesaplanır (TL/km)",
      "\"Sınırsız km\" gerçekten sınırsız mı, hangi kampanyalarda çıkar",
      "Tek yön kiralamada km nasıl işler",
      "Uzun yol planında km bütçesi çıkarma (örnek: İstanbul–Antalya gidiş-dönüş)"
    ],
    "not": "Bu kümede rakip içeriği de zayıf; hızlı kazanım adayı."
  },
  {
    "no": 2,
    "baslik": "Araç Kiralama Şirketi Nasıl Seçilir? Karşılaştırmadan Önce Bakılacak 9 Madde",
    "kume": "kurumsal / filo / operasyonel",
    "seviye": "zayif",
    "hacim": 71340,
    "kelimeSayisi": 512,
    "bosluk": "Kümenin hacmi en büyük ikinci, ama tek yazı var ve o da maliyet odaklı — \"seçim kriteri\" içeriği yok.",
    "kws": [
      {
        "kw": "araç kiralama şirketleri",
        "vol": 4400
      },
      {
        "kw": "araç kiralama şirketi",
        "vol": 4400
      },
      {
        "kw": "araç kiralayan şirketler",
        "vol": 4400
      },
      {
        "kw": "filo araç kiralama",
        "vol": 5400
      },
      {
        "kw": "kurumsal araç kiralama",
        "vol": 5400
      },
      {
        "kw": "araba kiralama şirketleri",
        "vol": 1900
      },
      {
        "kw": "araç kiralama firmaları",
        "vol": 1600
      }
    ],
    "sorular": [
      "Ofis ağı ve teslim noktası yoğunluğu",
      "Filo yaşı ve model çeşitliliği",
      "Sigorta / muafiyet paketlerinin okunması",
      "Depozito ve provizyon politikası",
      "Yol yardım SLA'sı",
      "Sözleşmedeki gizli ücret kalemleri",
      "Kurumsal fatura ve KDV",
      "Değerlendirme puanı nasıl okunur"
    ],
    "not": "Marka adı geçirmeden yazılmalı; karşılaştırma tablosu formatı uygun."
  },
  {
    "no": 3,
    "baslik": "Şoförlü Araç Kiralama: Ne Zaman Mantıklı, Fiyat Neye Göre Belirlenir?",
    "kume": "şoförlü / transfer / VIP",
    "seviye": "zayif",
    "hacim": 9270,
    "kelimeSayisi": 102,
    "bosluk": "Kümede tek yazı var, o da düğün / özel etkinlik odaklı.",
    "kws": [
      {
        "kw": "vip araç kiralama",
        "vol": 2400
      },
      {
        "kw": "şöförlü araç kiralama",
        "vol": 1600
      },
      {
        "kw": "günlük şoförlü araç kiralama fiyatları",
        "vol": 260
      },
      {
        "kw": "vip minibüs kiralama",
        "vol": 260
      },
      {
        "kw": "kiralık vip araç",
        "vol": 260
      },
      {
        "kw": "şoför kiralama",
        "vol": 210
      }
    ],
    "sorular": [
      "Şoförlü vs şoförsüz maliyet kırılımı",
      "Mesai / konaklama / yemek kalemleri şoför ücretine dahil mi",
      "Kurumsal misafir karşılama ve havalimanı transferi senaryosu",
      "Şoförün sorumluluğu ve sigorta kapsamı",
      "Günlük saat limiti"
    ],
    "not": "\"Şöförlü\" (yaygın yanlış yazım) hacmi gerçek — H2 / alt başlıkta doğal geçirilmeli, başlıkta değil."
  },
  {
    "no": 4,
    "baslik": "Yurt Dışında Araç Kiralama Rehberi: Uluslararası Ehliyet, Kredi Kartı ve Sigorta",
    "kume": "yurt dışı / sınır geçişi",
    "seviye": "zayif",
    "hacim": 5290,
    "kelimeSayisi": 34,
    "bosluk": "İki yazı var ama ikisi de Türkiye'den arabayla çıkış (Balkanlar rotası) — yurt dışında kiralama konusu hiç yok.",
    "kws": [
      {
        "kw": "yurt dışında araç kiralama",
        "vol": 1900
      },
      {
        "kw": "yurtdışı araç kiralama",
        "vol": 1900
      },
      {
        "kw": "yurtdışı araç kiralama kampanya",
        "vol": 260
      },
      {
        "kw": "yurtdışı araba kiralama",
        "vol": 260
      },
      {
        "kw": "araç kiralama yurtdışı",
        "vol": 210
      },
      {
        "kw": "yurtdışı araç kiralama siteleri",
        "vol": 70
      }
    ],
    "sorular": [
      "Uluslararası sürücü belgesi (IDP) hangi ülkede zorunlu",
      "TC ehliyeti nerede geçerli",
      "Kredi kartı üzerinden blokaj tutarları",
      "CDW / SCDW farkı ve yurt dışı muafiyet",
      "Yaş sınırının ülkeye göre değişmesi",
      "Yakıt politikası farkları",
      "Yol vinyet / otoyol etiketi"
    ],
    "not": "Europcar'ın uluslararası ağı doğal bir kapanış argümanı — ama içerik jenerik kalmalı."
  },
  {
    "no": 5,
    "baslik": "Stajyer Ehliyetle Araç Kiralanır mı? Genç Sürücü Paketi ve \"1 Yıl\" Kuralı",
    "kume": "ehliyet yaşı / stajyer / genç sürücü",
    "seviye": "zayif",
    "hacim": 3740,
    "kelimeSayisi": 73,
    "bosluk": "Mevcut \"Ehliyet Yaşı ve Sürücü Belgesi Şartları\" yazısı stajyer / genç sürücü paketi / 1 yıl kırılımını karşılamıyor (eşleşme skoru 0,33–0,50).",
    "kws": [
      {
        "kw": "ehliyet 1 yıl dolmadan araç kiralama",
        "vol": 390
      },
      {
        "kw": "stajyer ehliyet araç kiralama",
        "vol": 260
      },
      {
        "kw": "araç kiralama yaş sınırı",
        "vol": 210
      },
      {
        "kw": "genç sürücü paketi",
        "vol": 170
      },
      {
        "kw": "1 yıllık ehliyet araç kiralama",
        "vol": 140
      },
      {
        "kw": "stajyer ehliyet araba kiralama",
        "vol": 140
      },
      {
        "kw": "yeni ehliyet araç kiralama",
        "vol": 110
      },
      {
        "kw": "6 aylık ehliyet araç kiralama",
        "vol": 90
      },
      {
        "kw": "ehliyet aldıktan sonra araba kiralama",
        "vol": 90
      },
      {
        "kw": "araba kiralama yaş sınırı",
        "vol": 70
      },
      {
        "kw": "genç sürücü paketi ile araç kiralama",
        "vol": 70
      }
    ],
    "sorular": [
      "\"Ehliyet kaç yıllık olmalı\" kuralının kaynağı",
      "Stajyer ehliyet ile hangi segmentler kiralanabilir",
      "Genç sürücü ek ücreti (young driver fee) nedir, nasıl hesaplanır",
      "21 / 23 / 25 yaş eşikleri ve segment kısıtı",
      "Alternatif: ek sürücü olarak eklenmek"
    ],
    "not": "Mevcut yazıya bölüm eklemek yerine ayrı yazı — arama niyeti farklı ve uzun kuyruk çok geniş."
  },
  {
    "no": 6,
    "baslik": "Kiralık Araca Yazılan Trafik Cezası Nasıl Sorgulanır ve Ödenir?",
    "kume": "trafik cezası & HGS/OGS",
    "seviye": "zayif",
    "hacim": 2180,
    "kelimeSayisi": 10,
    "bosluk": "Mevcut \"Kiralık Araca Ceza Gelirse Ne Olur?\" yazısı süreci anlatıyor ama sorgulama / ödeme adımını karşılamıyor — kelimelerin tamamı \"sorgulama\" ve \"ödeme\" fiiliyle geliyor.",
    "kws": [
      {
        "kw": "kiralık araç ceza sorgulama",
        "vol": 590
      },
      {
        "kw": "kiralık araç trafik ceza sorgulama",
        "vol": 390
      },
      {
        "kw": "kiralık araç trafik cezası sorgulama",
        "vol": 390
      },
      {
        "kw": "kiralık araç trafik cezası ödeme",
        "vol": 390
      },
      {
        "kw": "kiralık araca yazılan ceza sorgulama",
        "vol": 260
      },
      {
        "kw": "kiralık araç plakasına yazılan ceza sorgulama",
        "vol": 40
      },
      {
        "kw": "kiralık araç radar cezası sorgulama",
        "vol": 40
      }
    ],
    "sorular": [
      "e-Devlet'ten plaka ile sorgulama adımları (ekran ekran)",
      "Ceza kiralama şirketine mi sürücüye mi tebliğ edilir",
      "%25 peşin indirim süresi kaçırılırsa",
      "HGS / OGS ihlali ile trafik cezasının farkı",
      "Kiralama şirketinin işlem ücreti",
      "İtiraz süreci ve süresi"
    ],
    "not": "Mevcut yazıya iç link verilmeli; kannibalizasyon riski var, bu yüzden bu yazı \"nasıl yapılır\" ekseninde kalmalı."
  },
  {
    "no": 7,
    "baslik": "6 Aylık ve Yıllık Araç Kiralama: Orta Vadeli Kiralama Kime Uygun?",
    "kume": "uzun dönem / aylık kiralama",
    "seviye": "zayif",
    "hacim": 4520,
    "kelimeSayisi": 325,
    "bosluk": "Blogda uzun dönem yazısı var ama kurumsal eksenli; süre bazlı arama niyeti karşılanmıyor. \"Yıllık / 6 aylık\" kelimeleri blogda hiç geçmiyor.",
    "kws": [
      {
        "kw": "yıllık araç kiralama",
        "vol": 3600
      },
      {
        "kw": "6 aylık araç kiralama",
        "vol": 390
      },
      {
        "kw": "6 aylık araç kiralama fiyatları",
        "vol": 260
      },
      {
        "kw": "1 yıllık araç kiralama",
        "vol": 260
      },
      {
        "kw": "uzun dönem araç kiralama fiyat hesaplama",
        "vol": 210
      }
    ],
    "sorular": [
      "Günlük × 180 gün vs 6 aylık paket maliyet karşılaştırması (tablo)",
      "Satın alma / kredi / kiralama üçlü kıyası",
      "Bakım - lastik - muayene kime ait",
      "Erken çıkış (early termination) bedeli",
      "Bireysel müşteri orta vadeli kiralayabilir mi"
    ],
    "not": "Fiyat hesaplama tablosu snippet potansiyeli taşır."
  },
  {
    "no": 8,
    "baslik": "Minibüs ve 9 Kişilik Araç Kiralama: Kalabalık Grupla Yolculuk Rehberi",
    "kume": "araç segmenti",
    "seviye": "sifir",
    "hacim": 4650,
    "kelimeSayisi": 4,
    "bosluk": "Blogda \"minibüs\" kelimesi hiç geçmiyor.",
    "kws": [
      {
        "kw": "minibüs kiralama",
        "vol": 2400
      },
      {
        "kw": "kiralık minibüs",
        "vol": 1600
      },
      {
        "kw": "kiralık minibüs şoförsüz",
        "vol": 390
      },
      {
        "kw": "vip minibüs kiralama",
        "vol": 260
      }
    ],
    "sorular": [
      "8+1 araç için B sınıfı ehliyet yeter mi, D1 ne zaman gerekir",
      "Şoförsüz minibüs kiralama şartları",
      "Bagaj hacmi ve kişi başı yük hesabı",
      "Yakıt tüketimi ve otoyol geçiş sınıfı farkı (2. sınıf araç)",
      "Grup seyahatinde maliyetin kişi başı düşmesi"
    ],
    "not": "Otoyol geçiş sınıfı detayı rakiplerde yok — ayrıştırıcı bölüm."
  },
  {
    "no": 9,
    "baslik": "Ticari Araç Kiralama: Panelvan, Kamyonet ve Taşıma İşleri İçin Doğru Araç Seçimi",
    "kume": "araç segmenti",
    "seviye": "sifir",
    "hacim": 1900,
    "kelimeSayisi": 5,
    "bosluk": "\"Ticari / panelvan / kamyonet\" kelimelerinin hiçbiri blogda geçmiyor.",
    "kws": [
      {
        "kw": "ticari araç kiralama",
        "vol": 1900
      },
      {
        "kw": "kiralık panelvan",
        "vol": 0
      },
      {
        "kw": "kamyonet kiralama",
        "vol": 0
      },
      {
        "kw": "kiralık ticari araç",
        "vol": 0
      }
    ],
    "sorular": [
      "m³ ve yük kapasitesine göre araç seçimi (tablo: panelvan / uzun şasi / kamyonet)",
      "Taşıma irsaliyesi ve yasal sorumluluk",
      "K belgesi gerekir mi",
      "Esnaf / şirket için KDV ve gider yazma",
      "Günlük vs aylık ticari kiralama maliyeti"
    ],
    "not": "Kurumsal segmentte dönüşüm değeri yüksek; hacimden çok niyet kalitesi için yazılıyor. Hacmi 0 görünen kelimeler Keyword Planner'da eşik altında kaldı."
  },
  {
    "no": 10,
    "baslik": "Lüks Araç Kiralama: Fiyatı Neye Göre Değişir, Depozito Neden Yüksektir?",
    "kume": "araç segmenti",
    "seviye": "sifir",
    "hacim": 3800,
    "kelimeSayisi": 3,
    "bosluk": "\"Lüks\" kelimesi blogda hiç geçmiyor; en yakın yazı düğün / özel etkinlik odaklı.",
    "kws": [
      {
        "kw": "lüks araç kiralama",
        "vol": 1900
      },
      {
        "kw": "lüks araç kira",
        "vol": 1900
      },
      {
        "kw": "kiralık lüks araba",
        "vol": 0
      }
    ],
    "sorular": [
      "Premium segmentte depozito / provizyon neden 5–10 kat yüksek",
      "Muafiyetli sigorta (SCDW) premium araçta neyi kapsamaz",
      "Yaş ve ehliyet kıdemi şartının segmentle sıkılaşması",
      "Km sınırının premium segmentte daralması (1 numaralı yazıyla iç link)",
      "Teslim öncesi hasar tutanağının önemi"
    ],
    "not": "3 numaralı yazıyla (şoförlü / VIP) kelime örtüşmesi var — 3 hizmet modeli, 10 segment / maliyet ekseninde ayrıştırılmalı, iç link verilmeli."
  }
];

export const LOKASYON_OZET = {
  "europcar": {
    "sehir": 33,
    "ofis": 79,
    "tr": 113,
    "trEn": 226
  },
  "sixt": {
    "sehir": 0,
    "ofis": 47,
    "tr": 48,
    "trEn": 96,
    "kokSeviye": 23
  },
  "kalip": {
    "europcarTr": "/konumlar/<sehir>/<ofis>",
    "europcarEn": "/en/locations/<sehir>/<ofis>",
    "sixtTr": "/kiralama-noktalari/<ofis>-arac-kiralama",
    "sixtEn": "/en/car-rental/<ofis>-car-rental"
  },
  "tip": [
    {
      "tip": "havalimanı",
      "ec": 38,
      "sx": 23
    },
    {
      "tip": "ilçe / tatil ofisi",
      "ec": 22,
      "sx": 13
    },
    {
      "tip": "şehir merkez",
      "ec": 13,
      "sx": 6
    },
    {
      "tip": "tren garı",
      "ec": 5,
      "sx": 0
    },
    {
      "tip": "AVM",
      "ec": 1,
      "sx": 3
    },
    {
      "tip": "otel",
      "ec": 0,
      "sx": 2
    }
  ],
  "kelime": {
    "ecOfisMin": 193,
    "ecOfisMedyan": 255,
    "ecOfisMax": 1286,
    "sxOfisMin": 1223,
    "sxOfisMedyan": 1838,
    "sxOfisMax": 2051,
    "kat": "7,2×"
  }
};

export const LOKASYON_BULGULARI = [
  {
    "seviye": "kritik",
    "baslik": "79 ofis sayfasının 78'inde editoryal metin yok",
    "metin": "Sayfalarda yalnızca H1, ofis adı, çalışma saatleri tablosu, telefon, harita linki ve her sayfada birebir tekrarlanan 33 şehirlik link listesi var. Gövde metni ~25 kelime; ölçülen 255 kelimenin kalanı nav + footer boilerplate."
  },
  {
    "seviye": "firsat",
    "baslik": "Şablon içeriği taşıyabiliyor — kanıt tek sayfada duruyor",
    "metin": "/konumlar/mugla/bodrum-milas-havalimani 1.286 kelime: şehir sayfalarındaki SEO metin bloğu (Görülmesi Gereken Yerler, Ne Yenir, Fiyatlar…) bu ofis sayfasına uygulanmış. Yani teknik engel yok, 78 sayfada metin yazılmamış. Ölçek için tek referans bu sayfa."
  },
  {
    "seviye": "kritik",
    "baslik": "Sixt ofis sayfası medyanı 1.838 kelime, Europcar 255",
    "metin": "7,2× fark. Sixt'in yapısı zengin: 'Araç Teslim Alma & Etme', 'Yakındaki Şubeler', 'Açılış/Kapanış Saatleri', 'İletişim', 'Sık Sorulan Sorular' + sayfa başına 23–45 H3."
  },
  {
    "seviye": "orta",
    "baslik": "FAQ schema Sixt'te var, Europcar'da yok",
    "metin": "Sixt ofis sayfalarında FAQPage + Question/Answer JSON-LD var (rich result adayı). Europcar'da ise AutoRental + GeoCoordinates + OpeningHoursSpecification + PostalAddress var, Sixt'te yok. İkisi de diğerinin güçlü olduğu şemayı kaçırıyor."
  },
  {
    "seviye": "kritik",
    "baslik": "Bozuk sayfa: /konumlar/istanbul/merkez-operasyon-servis",
    "metin": "Sitemap'te ama H1 boş, title/description jenerik ana sayfa metni, lokasyon içeriği yok (193 kelime). Hub sayfasından da link verilmiyor. Sitemap'ten çıkarılmalı ya da doldurulmalı."
  },
  {
    "seviye": "orta",
    "baslik": "/konumlar/paris kovası 2.611 yurt dışı ofise link veriyor",
    "metin": "Bu sayfalar sitemap'te değil ve noindex, follow — indekslenmiyor ama hub'dan 2.611 link crawl bütçesi harcıyor ve /konumlar hub'ının 7.335 kelimesinin çoğunu bu liste oluşturuyor. Şehir listesinde 'Paris araç kiralama' Türkiye şehirleriyle aynı seviyede görünüyor."
  },
  {
    "seviye": "orta",
    "baslik": "EN slug'ları Türkçe kalmış",
    "metin": "/en/locations/istanbul/istanbul-havalimani — 'istanbul airport car rental' araması için slug sinyali yok. Sixt EN tarafında slug'ları çevirmiş: /en/car-rental/istanbul-airport-car-rental."
  },
  {
    "seviye": "firsat",
    "baslik": "Havalimanı ve tren garında Europcar önde",
    "metin": "38 havalimanı ofis sayfası (Sixt 23). Sixt'te olup Europcar'da olmayan tek havalimanı: Van Ferit Melen. Tersi 13: Alanya Gazipaşa, Balıkesir Edremit, Batman, Çanakkale, Denizli Çardak, Elazığ, Erzincan, Eskişehir, Hatay, Kars, Muş, Nevşehir Kapadokya, Sivas. Ayrıca 5 tren garı ofisi var, Sixt'te bu tipte sayfa hiç yok — rekabetsiz alan."
  },
  {
    "seviye": "orta",
    "baslik": "İstanbul'da ve şehir kapsamında Sixt daha derin",
    "metin": "Sixt'in 12 İstanbul noktası var (otel ve AVM noktalarını ayrı sayfa yapıyor), Europcar'ın 9. Sixt'te olup Europcar'da lokasyonu olmayan şehirler: Van, Sakarya, Tekirdağ (Çorlu)."
  }
];

export const LOKASYON_SAYFALARI = [
  {
    "url": "https://www.europcar.com.tr/konumlar/paris",
    "ad": "(Yurt dışı toplu / Paris) (şehir sayfası)",
    "tip": "sehir",
    "sehir": "(Yurt dışı toplu / Paris)",
    "kelime": 6859,
    "h1": "Europcar Paris"
  },
  {
    "url": "https://www.europcar.com.tr/konumlar/adana",
    "ad": "Adana (şehir sayfası)",
    "tip": "sehir",
    "sehir": "Adana",
    "kelime": 894,
    "h1": "Adana Araç Kiralama"
  },
  {
    "url": "https://www.europcar.com.tr/konumlar/adana/adana-sehir",
    "ad": "Adana Sehir",
    "tip": "sehir-merkez",
    "sehir": "Adana",
    "kelime": 260,
    "h1": "Adana Araç Kiralama Ofisi"
  },
  {
    "url": "https://www.europcar.com.tr/konumlar/ankara",
    "ad": "Ankara (şehir sayfası)",
    "tip": "sehir",
    "sehir": "Ankara",
    "kelime": 1130,
    "h1": "Ankara Araç Kiralama"
  },
  {
    "url": "https://www.europcar.com.tr/konumlar/ankara/ankara-esenboga-havalimani",
    "ad": "Ankara Esenboga Havalimani",
    "tip": "havalimani",
    "sehir": "Ankara",
    "kelime": 251,
    "h1": "Ankara Esenboğa Havalimanı Araç Kiralama"
  },
  {
    "url": "https://www.europcar.com.tr/konumlar/ankara/ankara-tren-gari",
    "ad": "Ankara Tren Gari",
    "tip": "tren-gari",
    "sehir": "Ankara",
    "kelime": 259,
    "h1": "Ankara Tren Garı Araç Kiralama"
  },
  {
    "url": "https://www.europcar.com.tr/konumlar/antalya/alanya-gazipasa-havalimani",
    "ad": "Alanya Gazipasa Havalimani",
    "tip": "havalimani",
    "sehir": "Antalya",
    "kelime": 254,
    "h1": "Alanya Gazipaşa Havalimanı Araç Kiralama"
  },
  {
    "url": "https://www.europcar.com.tr/konumlar/antalya",
    "ad": "Antalya (şehir sayfası)",
    "tip": "sehir",
    "sehir": "Antalya",
    "kelime": 1272,
    "h1": "Antalya Araç Kiralama"
  },
  {
    "url": "https://www.europcar.com.tr/konumlar/antalya/antalya-alanya",
    "ad": "Antalya Alanya",
    "tip": "ilce-tatil-ofisi",
    "sehir": "Antalya",
    "kelime": 255,
    "h1": "Antalya Alanya Araç Kiralama"
  },
  {
    "url": "https://www.europcar.com.tr/konumlar/antalya/antalya-belek",
    "ad": "Antalya Belek",
    "tip": "ilce-tatil-ofisi",
    "sehir": "Antalya",
    "kelime": 258,
    "h1": "Antalya Belek Araç Kiralama"
  },
  {
    "url": "https://www.europcar.com.tr/konumlar/antalya/antalya-havalimani-dis-hatlar-t1",
    "ad": "Antalya Havalimani Dis Hatlar T1",
    "tip": "havalimani",
    "sehir": "Antalya",
    "kelime": 255,
    "h1": "Antalya Havalimanı T1 Araç Kiralama"
  },
  {
    "url": "https://www.europcar.com.tr/konumlar/antalya/antalya-havalimani-dis-hatlar-t2",
    "ad": "Antalya Havalimani Dis Hatlar T2",
    "tip": "havalimani",
    "sehir": "Antalya",
    "kelime": 253,
    "h1": "Antalya Havalimanı T2 Araç Kiralama"
  },
  {
    "url": "https://www.europcar.com.tr/konumlar/antalya/antalya-havalimani-ic-hatlar",
    "ad": "Antalya Havalimani Ic Hatlar",
    "tip": "havalimani",
    "sehir": "Antalya",
    "kelime": 256,
    "h1": "Antalya Havalimanı İç Hatlar Araç Kiralama"
  },
  {
    "url": "https://www.europcar.com.tr/konumlar/antalya/antalya-kemer",
    "ad": "Antalya Kemer",
    "tip": "ilce-tatil-ofisi",
    "sehir": "Antalya",
    "kelime": 258,
    "h1": "Antalya Kemer Araç Kiralama"
  },
  {
    "url": "https://www.europcar.com.tr/konumlar/antalya/antalya-lara---kundu",
    "ad": "Antalya Lara Kundu",
    "tip": "ilce-tatil-ofisi",
    "sehir": "Antalya",
    "kelime": 272,
    "h1": "Antalya Lara Kundu Araç Kiralama"
  },
  {
    "url": "https://www.europcar.com.tr/konumlar/antalya/antalya-side",
    "ad": "Antalya Side",
    "tip": "ilce-tatil-ofisi",
    "sehir": "Antalya",
    "kelime": 256,
    "h1": "Antalya Side Araç Kiralama"
  },
  {
    "url": "https://www.europcar.com.tr/konumlar/aydin/aydin-didim",
    "ad": "Aydin Didim",
    "tip": "ilce-tatil-ofisi",
    "sehir": "Aydın",
    "kelime": 248,
    "h1": "Didim Araç Kiralama"
  },
  {
    "url": "https://www.europcar.com.tr/konumlar/aydin/aydin-kusadasi",
    "ad": "Aydin Kusadasi",
    "tip": "ilce-tatil-ofisi",
    "sehir": "Aydın",
    "kelime": 249,
    "h1": "Kuşadası Araç Kiralama"
  },
  {
    "url": "https://www.europcar.com.tr/konumlar/aydin",
    "ad": "Aydın (şehir sayfası)",
    "tip": "sehir",
    "sehir": "Aydın",
    "kelime": 1944,
    "h1": "Aydın Araç Kiralama"
  },
  {
    "url": "https://www.europcar.com.tr/konumlar/balikesir/balikesir-edremit-koca-seyit-havalimani",
    "ad": "Balikesir Edremit Koca Seyit Havalimani",
    "tip": "havalimani",
    "sehir": "Balıkesir",
    "kelime": 255,
    "h1": "Edremit Havalimanı Araç Kiralama"
  },
  {
    "url": "https://www.europcar.com.tr/konumlar/balikesir",
    "ad": "Balıkesir (şehir sayfası)",
    "tip": "sehir",
    "sehir": "Balıkesir",
    "kelime": 2115,
    "h1": "Balıkesir Araç Kiralama"
  },
  {
    "url": "https://www.europcar.com.tr/konumlar/batman",
    "ad": "Batman (şehir sayfası)",
    "tip": "sehir",
    "sehir": "Batman",
    "kelime": 2127,
    "h1": "Batman Araç Kiralama"
  },
  {
    "url": "https://www.europcar.com.tr/konumlar/batman/batman-havalimani",
    "ad": "Batman Havalimani",
    "tip": "havalimani",
    "sehir": "Batman",
    "kelime": 258,
    "h1": "Batman Havalimanı Araç Kiralama"
  },
  {
    "url": "https://www.europcar.com.tr/konumlar/bursa",
    "ad": "Bursa (şehir sayfası)",
    "tip": "sehir",
    "sehir": "Bursa",
    "kelime": 1085,
    "h1": "Bursa Araç Kiralama"
  },
  {
    "url": "https://www.europcar.com.tr/konumlar/bursa/bursa-sehir",
    "ad": "Bursa Sehir",
    "tip": "sehir-merkez",
    "sehir": "Bursa",
    "kelime": 253,
    "h1": "Bursa Araç Kiralama Ofisi"
  },
  {
    "url": "https://www.europcar.com.tr/konumlar/denizli",
    "ad": "Denizli (şehir sayfası)",
    "tip": "sehir",
    "sehir": "Denizli",
    "kelime": 1528,
    "h1": "Denizli Araç Kiralama"
  },
  {
    "url": "https://www.europcar.com.tr/konumlar/denizli/denizli-cardak-havalimani",
    "ad": "Denizli Cardak Havalimani",
    "tip": "havalimani",
    "sehir": "Denizli",
    "kelime": 255,
    "h1": "Denizli Çardak Havalimanı Araç Kiralama"
  },
  {
    "url": "https://www.europcar.com.tr/konumlar/denizli/denizli-sehir",
    "ad": "Denizli Sehir",
    "tip": "sehir-merkez",
    "sehir": "Denizli",
    "kelime": 252,
    "h1": "Denizli Araç Kiralama Ofisi"
  },
  {
    "url": "https://www.europcar.com.tr/konumlar/diyarbakir/diyarbakir-havalimani",
    "ad": "Diyarbakir Havalimani",
    "tip": "havalimani",
    "sehir": "Diyarbakır",
    "kelime": 256,
    "h1": "Diyarbakır Havalimanı Araç Kiralama"
  },
  {
    "url": "https://www.europcar.com.tr/konumlar/diyarbakir",
    "ad": "Diyarbakır (şehir sayfası)",
    "tip": "sehir",
    "sehir": "Diyarbakır",
    "kelime": 2031,
    "h1": "Diyarbakır Araç Kiralama"
  },
  {
    "url": "https://www.europcar.com.tr/konumlar/elazig/elazig-havalimani",
    "ad": "Elazig Havalimani",
    "tip": "havalimani",
    "sehir": "Elazığ",
    "kelime": 254,
    "h1": "Elazığ Havalimanı Araç Kiralama"
  },
  {
    "url": "https://www.europcar.com.tr/konumlar/elazig",
    "ad": "Elazığ (şehir sayfası)",
    "tip": "sehir",
    "sehir": "Elazığ",
    "kelime": 1895,
    "h1": "Elazığ Araç Kiralama"
  },
  {
    "url": "https://www.europcar.com.tr/konumlar/erzincan",
    "ad": "Erzincan (şehir sayfası)",
    "tip": "sehir",
    "sehir": "Erzincan",
    "kelime": 2184,
    "h1": "Erzincan Araç Kiralama"
  },
  {
    "url": "https://www.europcar.com.tr/konumlar/erzincan/erzincan-havalimani",
    "ad": "Erzincan Havalimani",
    "tip": "havalimani",
    "sehir": "Erzincan",
    "kelime": 250,
    "h1": "Erzincan Havalimanı Araç Kiralama"
  },
  {
    "url": "https://www.europcar.com.tr/konumlar/erzincan/erzincan-sehir",
    "ad": "Erzincan Sehir",
    "tip": "sehir-merkez",
    "sehir": "Erzincan",
    "kelime": 255,
    "h1": "Erzincan Araç Kiralama Ofisi"
  },
  {
    "url": "https://www.europcar.com.tr/konumlar/erzurum",
    "ad": "Erzurum (şehir sayfası)",
    "tip": "sehir",
    "sehir": "Erzurum",
    "kelime": 2195,
    "h1": "Erzurum Araç Kiralama"
  },
  {
    "url": "https://www.europcar.com.tr/konumlar/erzurum/erzurum-havalimani",
    "ad": "Erzurum Havalimani",
    "tip": "havalimani",
    "sehir": "Erzurum",
    "kelime": 255,
    "h1": "Erzurum Havalimanı Araç Kiralama"
  },
  {
    "url": "https://www.europcar.com.tr/konumlar/eskisehir/eskisehir-havalimani",
    "ad": "Eskisehir Havalimani",
    "tip": "havalimani",
    "sehir": "Eskişehir",
    "kelime": 261,
    "h1": "Eskişehir Havalimanı Araç Kiralama"
  },
  {
    "url": "https://www.europcar.com.tr/konumlar/eskisehir/eskisehir-sehir",
    "ad": "Eskisehir Sehir",
    "tip": "sehir-merkez",
    "sehir": "Eskişehir",
    "kelime": 255,
    "h1": "Eskişehir Araç Kiralama Ofisi"
  },
  {
    "url": "https://www.europcar.com.tr/konumlar/eskisehir/eskisehir-tren-gari",
    "ad": "Eskisehir Tren Gari",
    "tip": "tren-gari",
    "sehir": "Eskişehir",
    "kelime": 253,
    "h1": "Eskişehir Tren Garı Araç Kiralama"
  },
  {
    "url": "https://www.europcar.com.tr/konumlar/eskisehir",
    "ad": "Eskişehir (şehir sayfası)",
    "tip": "sehir",
    "sehir": "Eskişehir",
    "kelime": 1785,
    "h1": "Eskişehir Araç Kiralama"
  },
  {
    "url": "https://www.europcar.com.tr/konumlar/gaziantep",
    "ad": "Gaziantep (şehir sayfası)",
    "tip": "sehir",
    "sehir": "Gaziantep",
    "kelime": 802,
    "h1": "Gaziantep Araç Kiralama"
  },
  {
    "url": "https://www.europcar.com.tr/konumlar/gaziantep/gaziantep-havalimani-dis-hatlar",
    "ad": "Gaziantep Havalimani Dis Hatlar",
    "tip": "havalimani",
    "sehir": "Gaziantep",
    "kelime": 260,
    "h1": "Gaziantep Dış Hatlar Araç Kiralama"
  },
  {
    "url": "https://www.europcar.com.tr/konumlar/gaziantep/gaziantep-havalimani-ic-hatlar",
    "ad": "Gaziantep Havalimani Ic Hatlar",
    "tip": "havalimani",
    "sehir": "Gaziantep",
    "kelime": 260,
    "h1": "Gaziantep İç Hatlar Araç Kiralama"
  },
  {
    "url": "https://www.europcar.com.tr/konumlar/hatay",
    "ad": "Hatay (şehir sayfası)",
    "tip": "sehir",
    "sehir": "Hatay",
    "kelime": 1954,
    "h1": "Hatay Araç Kiralama"
  },
  {
    "url": "https://www.europcar.com.tr/konumlar/hatay/hatay-havalimani",
    "ad": "Hatay Havalimani",
    "tip": "havalimani",
    "sehir": "Hatay",
    "kelime": 257,
    "h1": "Hatay Havalimanı Araç Kiralama"
  },
  {
    "url": "https://www.europcar.com.tr/konumlar/hatay/hatay-sehir",
    "ad": "Hatay Sehir",
    "tip": "sehir-merkez",
    "sehir": "Hatay",
    "kelime": 255,
    "h1": "Hatay Araç Kiralama Ofisi"
  },
  {
    "url": "https://www.europcar.com.tr/konumlar/kars/kars",
    "ad": "Kars",
    "tip": "ilce-tatil-ofisi",
    "sehir": "Kars",
    "kelime": 256,
    "h1": "Kars Araç Kiralama Ofisi"
  },
  {
    "url": "https://www.europcar.com.tr/konumlar/kars",
    "ad": "Kars (şehir sayfası)",
    "tip": "sehir",
    "sehir": "Kars",
    "kelime": 1230,
    "h1": "Kars Araç Kiralama"
  },
  {
    "url": "https://www.europcar.com.tr/konumlar/kars/kars-havalimani",
    "ad": "Kars Havalimani",
    "tip": "havalimani",
    "sehir": "Kars",
    "kelime": 256,
    "h1": "Kars Havalimanı Araç Kiralama"
  },
  {
    "url": "https://www.europcar.com.tr/konumlar/kayseri",
    "ad": "Kayseri (şehir sayfası)",
    "tip": "sehir",
    "sehir": "Kayseri",
    "kelime": 1815,
    "h1": "Kayseri Araç Kiralama"
  },
  {
    "url": "https://www.europcar.com.tr/konumlar/kayseri/kayseri-erkilet-havalimani",
    "ad": "Kayseri Erkilet Havalimani",
    "tip": "havalimani",
    "sehir": "Kayseri",
    "kelime": 267,
    "h1": "Kayseri Erkilet Havalimanı Araç Kiralama"
  },
  {
    "url": "https://www.europcar.com.tr/konumlar/kocaeli/izmit",
    "ad": "Izmit",
    "tip": "ilce-tatil-ofisi",
    "sehir": "Kocaeli",
    "kelime": 256,
    "h1": "Kocaeli İzmit Araç Kiralama"
  },
  {
    "url": "https://www.europcar.com.tr/konumlar/kocaeli",
    "ad": "Kocaeli (şehir sayfası)",
    "tip": "sehir",
    "sehir": "Kocaeli",
    "kelime": 1619,
    "h1": "Kocaeli Araç Kiralama"
  },
  {
    "url": "https://www.europcar.com.tr/konumlar/konya",
    "ad": "Konya (şehir sayfası)",
    "tip": "sehir",
    "sehir": "Konya",
    "kelime": 850,
    "h1": "Konya Araç Kiralama"
  },
  {
    "url": "https://www.europcar.com.tr/konumlar/konya/konya-havalimani",
    "ad": "Konya Havalimani",
    "tip": "havalimani",
    "sehir": "Konya",
    "kelime": 252,
    "h1": "Konya Havalimanı Araç Kiralama"
  },
  {
    "url": "https://www.europcar.com.tr/konumlar/konya/konya-sehir",
    "ad": "Konya Sehir",
    "tip": "sehir-merkez",
    "sehir": "Konya",
    "kelime": 253,
    "h1": "Konya Araç Kiralama Ofisi"
  },
  {
    "url": "https://www.europcar.com.tr/konumlar/konya/konya-tren-gari",
    "ad": "Konya Tren Gari",
    "tip": "tren-gari",
    "sehir": "Konya",
    "kelime": 257,
    "h1": "Konya Tren Garı Araç Kiralama"
  },
  {
    "url": "https://www.europcar.com.tr/konumlar/malatya",
    "ad": "Malatya (şehir sayfası)",
    "tip": "sehir",
    "sehir": "Malatya",
    "kelime": 2058,
    "h1": "Malatya Araç Kiralama"
  },
  {
    "url": "https://www.europcar.com.tr/konumlar/malatya/malatya-havalimani",
    "ad": "Malatya Havalimani",
    "tip": "havalimani",
    "sehir": "Malatya",
    "kelime": 252,
    "h1": "Malatya Havalimanı Araç Kiralama"
  },
  {
    "url": "https://www.europcar.com.tr/konumlar/malatya/malatya-sehir",
    "ad": "Malatya Sehir",
    "tip": "sehir-merkez",
    "sehir": "Malatya",
    "kelime": 257,
    "h1": "Malatya Araç Kiralama Ofisi"
  },
  {
    "url": "https://www.europcar.com.tr/konumlar/mardin",
    "ad": "Mardin (şehir sayfası)",
    "tip": "sehir",
    "sehir": "Mardin",
    "kelime": 1707,
    "h1": "Mardin Araç Kiralama"
  },
  {
    "url": "https://www.europcar.com.tr/konumlar/mardin/mardin-havalimani",
    "ad": "Mardin Havalimani",
    "tip": "havalimani",
    "sehir": "Mardin",
    "kelime": 250,
    "h1": "Mardin Havalimanı Araç Kiralama"
  },
  {
    "url": "https://www.europcar.com.tr/konumlar/mersin/cukurova-havalimani",
    "ad": "Cukurova Havalimani",
    "tip": "havalimani",
    "sehir": "Mersin",
    "kelime": 254,
    "h1": "Çukurova Havalimanı Araç Kiralama"
  },
  {
    "url": "https://www.europcar.com.tr/konumlar/mersin/cukurova-havalimani-dis-hatlar",
    "ad": "Cukurova Havalimani Dis Hatlar",
    "tip": "havalimani",
    "sehir": "Mersin",
    "kelime": 257,
    "h1": "Çukurova Dış Hatlar Araç Kiralama"
  },
  {
    "url": "https://www.europcar.com.tr/konumlar/mersin",
    "ad": "Mersin (şehir sayfası)",
    "tip": "sehir",
    "sehir": "Mersin",
    "kelime": 1950,
    "h1": "Mersin Araç Kiralama"
  },
  {
    "url": "https://www.europcar.com.tr/konumlar/mersin/mersin-sehir",
    "ad": "Mersin Sehir",
    "tip": "sehir-merkez",
    "sehir": "Mersin",
    "kelime": 254,
    "h1": "Mersin Araç Kiralama Ofisi"
  },
  {
    "url": "https://www.europcar.com.tr/konumlar/mersin/mersin-tasucu",
    "ad": "Mersin Tasucu",
    "tip": "ilce-tatil-ofisi",
    "sehir": "Mersin",
    "kelime": 256,
    "h1": "Mersin Taşucu Araç Kiralama"
  },
  {
    "url": "https://www.europcar.com.tr/konumlar/mugla/bodrum-milas-havalimani",
    "ad": "Bodrum Milas Havalimani",
    "tip": "havalimani",
    "sehir": "Muğla",
    "kelime": 1286,
    "h1": "Bodrum Milas Havalimanı Araç Kiralama"
  },
  {
    "url": "https://www.europcar.com.tr/konumlar/mugla/dalaman",
    "ad": "Dalaman",
    "tip": "ilce-tatil-ofisi",
    "sehir": "Muğla",
    "kelime": 250,
    "h1": "Dalaman Araç Kiralama"
  },
  {
    "url": "https://www.europcar.com.tr/konumlar/mugla/dalaman-havalimani-dis-hatlar",
    "ad": "Dalaman Havalimani Dis Hatlar",
    "tip": "havalimani",
    "sehir": "Muğla",
    "kelime": 263,
    "h1": "Dalaman Dış Hatlar Araç Kiralama"
  },
  {
    "url": "https://www.europcar.com.tr/konumlar/mugla/dalaman-havalimani-ic-hatlar",
    "ad": "Dalaman Havalimani Ic Hatlar",
    "tip": "havalimani",
    "sehir": "Muğla",
    "kelime": 263,
    "h1": "Dalaman İç Hatlar Araç Kiralama"
  },
  {
    "url": "https://www.europcar.com.tr/konumlar/mugla/mugla-dalyan",
    "ad": "Mugla Dalyan",
    "tip": "ilce-tatil-ofisi",
    "sehir": "Muğla",
    "kelime": 253,
    "h1": "Muğla Dalyan Araç Kiralama"
  },
  {
    "url": "https://www.europcar.com.tr/konumlar/mugla/mugla-fethiye",
    "ad": "Mugla Fethiye",
    "tip": "ilce-tatil-ofisi",
    "sehir": "Muğla",
    "kelime": 253,
    "h1": "Muğla Fethiye Araç Kiralama"
  },
  {
    "url": "https://www.europcar.com.tr/konumlar/mugla/mugla-marmaris",
    "ad": "Mugla Marmaris",
    "tip": "ilce-tatil-ofisi",
    "sehir": "Muğla",
    "kelime": 254,
    "h1": "Muğla Marmaris Araç Kiralama"
  },
  {
    "url": "https://www.europcar.com.tr/konumlar/mugla",
    "ad": "Muğla (şehir sayfası)",
    "tip": "sehir",
    "sehir": "Muğla",
    "kelime": 1701,
    "h1": "Muğla Araç Kiralama"
  },
  {
    "url": "https://www.europcar.com.tr/konumlar/mus/mus",
    "ad": "Mus",
    "tip": "ilce-tatil-ofisi",
    "sehir": "Muş",
    "kelime": 259,
    "h1": "Muş Araç Kiralama Ofisi"
  },
  {
    "url": "https://www.europcar.com.tr/konumlar/mus/mus-havalimani",
    "ad": "Mus Havalimani",
    "tip": "havalimani",
    "sehir": "Muş",
    "kelime": 254,
    "h1": "Muş Havalimanı Araç Kiralama"
  },
  {
    "url": "https://www.europcar.com.tr/konumlar/mus",
    "ad": "Muş (şehir sayfası)",
    "tip": "sehir",
    "sehir": "Muş",
    "kelime": 1875,
    "h1": "Muş Araç Kiralama"
  },
  {
    "url": "https://www.europcar.com.tr/konumlar/nevsehir/nevsehir-kapadokya-havalimani",
    "ad": "Nevsehir Kapadokya Havalimani",
    "tip": "havalimani",
    "sehir": "Nevşehir",
    "kelime": 254,
    "h1": "Kapadokya Havalimanı Araç Kiralama"
  },
  {
    "url": "https://www.europcar.com.tr/konumlar/nevsehir/nevsehir-urgup",
    "ad": "Nevsehir Urgup",
    "tip": "ilce-tatil-ofisi",
    "sehir": "Nevşehir",
    "kelime": 253,
    "h1": "Nevşehir Ürgüp Araç Kiralama"
  },
  {
    "url": "https://www.europcar.com.tr/konumlar/nevsehir",
    "ad": "Nevşehir (şehir sayfası)",
    "tip": "sehir",
    "sehir": "Nevşehir",
    "kelime": 2259,
    "h1": "Nevşehir Araç Kiralama"
  },
  {
    "url": "https://www.europcar.com.tr/konumlar/samsun",
    "ad": "Samsun (şehir sayfası)",
    "tip": "sehir",
    "sehir": "Samsun",
    "kelime": 1958,
    "h1": "Samsun Araç Kiralama"
  },
  {
    "url": "https://www.europcar.com.tr/konumlar/samsun/samsun-carsamba",
    "ad": "Samsun Carsamba",
    "tip": "ilce-tatil-ofisi",
    "sehir": "Samsun",
    "kelime": 254,
    "h1": "Samsun Çarşamba Araç Kiralama"
  },
  {
    "url": "https://www.europcar.com.tr/konumlar/samsun/samsun-carsamba-havalimani",
    "ad": "Samsun Carsamba Havalimani",
    "tip": "havalimani",
    "sehir": "Samsun",
    "kelime": 256,
    "h1": "Samsun Havalimanı Araç Kiralama"
  },
  {
    "url": "https://www.europcar.com.tr/konumlar/samsun/samsun-sehir",
    "ad": "Samsun Sehir",
    "tip": "sehir-merkez",
    "sehir": "Samsun",
    "kelime": 253,
    "h1": "Samsun Araç Kiralama Ofisi"
  },
  {
    "url": "https://www.europcar.com.tr/konumlar/sivas",
    "ad": "Sivas (şehir sayfası)",
    "tip": "sehir",
    "sehir": "Sivas",
    "kelime": 1848,
    "h1": "Sivas Araç Kiralama"
  },
  {
    "url": "https://www.europcar.com.tr/konumlar/sivas/sivas-havalimani",
    "ad": "Sivas Havalimani",
    "tip": "havalimani",
    "sehir": "Sivas",
    "kelime": 257,
    "h1": "Sivas Havalimanı Araç Kiralama"
  },
  {
    "url": "https://www.europcar.com.tr/konumlar/sivas/sivas-sehir",
    "ad": "Sivas Sehir",
    "tip": "sehir-merkez",
    "sehir": "Sivas",
    "kelime": 255,
    "h1": "Sivas Araç Kiralama Ofisi"
  },
  {
    "url": "https://www.europcar.com.tr/konumlar/sivas/sivas-tren-gari",
    "ad": "Sivas Tren Gari",
    "tip": "tren-gari",
    "sehir": "Sivas",
    "kelime": 252,
    "h1": "Sivas Tren Garı Araç Kiralama"
  },
  {
    "url": "https://www.europcar.com.tr/konumlar/trabzon",
    "ad": "Trabzon (şehir sayfası)",
    "tip": "sehir",
    "sehir": "Trabzon",
    "kelime": 1988,
    "h1": "Trabzon Araç Kiralama"
  },
  {
    "url": "https://www.europcar.com.tr/konumlar/trabzon/trabzon-havalimani-dis-hatlar",
    "ad": "Trabzon Havalimani Dis Hatlar",
    "tip": "havalimani",
    "sehir": "Trabzon",
    "kelime": 260,
    "h1": "Trabzon Dış Hatlar Araç Kiralama"
  },
  {
    "url": "https://www.europcar.com.tr/konumlar/trabzon/trabzon-havalimani-ic-hatlar",
    "ad": "Trabzon Havalimani Ic Hatlar",
    "tip": "havalimani",
    "sehir": "Trabzon",
    "kelime": 264,
    "h1": "Trabzon İç Hatlar Araç Kiralama"
  },
  {
    "url": "https://www.europcar.com.tr/konumlar/canakkale/canakkale",
    "ad": "Canakkale",
    "tip": "ilce-tatil-ofisi",
    "sehir": "Çanakkale",
    "kelime": 252,
    "h1": "Çanakkale Araç Kiralama Ofisi"
  },
  {
    "url": "https://www.europcar.com.tr/konumlar/canakkale/canakkale-havalimani",
    "ad": "Canakkale Havalimani",
    "tip": "havalimani",
    "sehir": "Çanakkale",
    "kelime": 257,
    "h1": "Çanakkale Havalimanı Araç Kiralama"
  },
  {
    "url": "https://www.europcar.com.tr/konumlar/canakkale",
    "ad": "Çanakkale (şehir sayfası)",
    "tip": "sehir",
    "sehir": "Çanakkale",
    "kelime": 886,
    "h1": "Çanakkale Araç Kiralama"
  },
  {
    "url": "https://www.europcar.com.tr/konumlar/istanbul/istanbul-atasehir",
    "ad": "Istanbul Atasehir",
    "tip": "ilce-tatil-ofisi",
    "sehir": "İstanbul",
    "kelime": 248,
    "h1": "İstanbul Ataşehir Araç Kiralama"
  },
  {
    "url": "https://www.europcar.com.tr/konumlar/istanbul/istanbul-bakirkoy-marmara-forum-avm",
    "ad": "Istanbul Bakirkoy Marmara Forum Avm",
    "tip": "avm",
    "sehir": "İstanbul",
    "kelime": 271,
    "h1": "İstanbul Bakırköy Marmara Forum AVM Araç Kiralama"
  },
  {
    "url": "https://www.europcar.com.tr/konumlar/istanbul/istanbul-havalimani",
    "ad": "Istanbul Havalimani",
    "tip": "havalimani",
    "sehir": "İstanbul",
    "kelime": 249,
    "h1": "İstanbul Havalimanı Araç Kiralama"
  },
  {
    "url": "https://www.europcar.com.tr/konumlar/istanbul/istanbul-kartal",
    "ad": "Istanbul Kartal",
    "tip": "ilce-tatil-ofisi",
    "sehir": "İstanbul",
    "kelime": 252,
    "h1": "İstanbul Kartal Araç Kiralama"
  },
  {
    "url": "https://www.europcar.com.tr/konumlar/istanbul/istanbul-pendik-yht",
    "ad": "Istanbul Pendik Yht",
    "tip": "tren-gari",
    "sehir": "İstanbul",
    "kelime": 258,
    "h1": "İstanbul Pendik YHT Araç Kiralama"
  },
  {
    "url": "https://www.europcar.com.tr/konumlar/istanbul/istanbul-sabiha-gokcen-havalimani",
    "ad": "Istanbul Sabiha Gokcen Havalimani",
    "tip": "havalimani",
    "sehir": "İstanbul",
    "kelime": 253,
    "h1": "Sabiha Gökçen Araç Kiralama"
  },
  {
    "url": "https://www.europcar.com.tr/konumlar/istanbul/istanbul-taksim",
    "ad": "Istanbul Taksim",
    "tip": "ilce-tatil-ofisi",
    "sehir": "İstanbul",
    "kelime": 257,
    "h1": "İstanbul Taksim Araç Kiralama"
  },
  {
    "url": "https://www.europcar.com.tr/konumlar/istanbul/istanbul-vadi",
    "ad": "Istanbul Vadi",
    "tip": "ilce-tatil-ofisi",
    "sehir": "İstanbul",
    "kelime": 257,
    "h1": "İstanbul Vadi Araç Kiralama"
  },
  {
    "url": "https://www.europcar.com.tr/konumlar/istanbul/merkez-operasyon-servis",
    "ad": "Merkez Operasyon Servis",
    "tip": "sehir-merkez",
    "sehir": "İstanbul",
    "kelime": 193,
    "h1": ""
  },
  {
    "url": "https://www.europcar.com.tr/konumlar/istanbul",
    "ad": "İstanbul (şehir sayfası)",
    "tip": "sehir",
    "sehir": "İstanbul",
    "kelime": 1612,
    "h1": "İstanbul Araç Kiralama"
  },
  {
    "url": "https://www.europcar.com.tr/konumlar/izmir/izmir-adnan-menderes-havalimani-dis-hatlar",
    "ad": "Izmir Adnan Menderes Havalimani Dis Hatlar",
    "tip": "havalimani",
    "sehir": "İzmir",
    "kelime": 256,
    "h1": "İzmir Havalimanı Dış Hatlar Araç Kiralama"
  },
  {
    "url": "https://www.europcar.com.tr/konumlar/izmir/izmir-adnan-menderes-havalimani-ic-hatlar",
    "ad": "Izmir Adnan Menderes Havalimani Ic Hatlar",
    "tip": "havalimani",
    "sehir": "İzmir",
    "kelime": 256,
    "h1": "İzmir Havalimanı İç Hatlar Araç Kiralama"
  },
  {
    "url": "https://www.europcar.com.tr/konumlar/izmir",
    "ad": "İzmir (şehir sayfası)",
    "tip": "sehir",
    "sehir": "İzmir",
    "kelime": 1235,
    "h1": "İzmir Araç Kiralama"
  },
  {
    "url": "https://www.europcar.com.tr/konumlar/sanliurfa/sanliurfa-gap-havalimani",
    "ad": "Sanliurfa Gap Havalimani",
    "tip": "havalimani",
    "sehir": "Şanlıurfa",
    "kelime": 256,
    "h1": "Şanlıurfa GAP Havalimanı Araç Kiralama"
  },
  {
    "url": "https://www.europcar.com.tr/konumlar/sanliurfa/sanliurfa-sehir",
    "ad": "Sanliurfa Sehir",
    "tip": "sehir-merkez",
    "sehir": "Şanlıurfa",
    "kelime": 256,
    "h1": "Şanlıurfa Araç Kiralama Ofisi"
  },
  {
    "url": "https://www.europcar.com.tr/konumlar/sanliurfa",
    "ad": "Şanlıurfa (şehir sayfası)",
    "tip": "sehir",
    "sehir": "Şanlıurfa",
    "kelime": 2061,
    "h1": "Şanlıurfa Araç Kiralama"
  }
];
